(function () {
	'use strict';
	angular.module('app.core')
		.service('tableRenderService', tableRenderService);

	tableRenderService.$inject = ['$rootScope', '$filter', '$translate', 'URLS', 'siteUrl', 'currencyFormatService', 'integerFormatService',
		'leanFilterService', 'drilldownFunctionsService', 'percentageFormatService', 'numberFormatService', 'projectRenderService', '$experiments', 'shortageCriticalityLevelService',
		'deliveryPerformanceTypeService', 'supplierListService', 'storeService'];

	function tableRenderService($rootScope, $filter, $translate, URLS, siteUrl, currencyFormatService, integerFormatService,
			leanFilterService, drilldownFunctionsService, percentageFormatService, numberFormatService, projectRenderService, $experiments, shortageCriticalityLevelService,
			deliveryPerformanceTypeService, supplierListService, storeService) {
		var spendSummaryHeaderMap = {};
		var colorClassMap = {
			'color-code-10-red': 'Red',
			'color-code-30-yellow': 'Yellow',
			'color-code-20-blue': 'Blue'
		};

		var excludeBlanketOrdersFilter = $experiments.isEnabled('supply-and-demand-blanket-checkbox');
		var scheduledDeliveriesHotSheetFlag = globalConfig.customer.scheduledDeliveriesHotSheetFlag;
		var scheduledDeliveriesHotSheetFlag = true;
		var isChatEnabled = $experiments.isEnabled('chat-enabled');
		var SPLIT_PO_MESSAGE = $translate.instant('Buyer and supplier delivery schedules do not match in ERP, commenting and sync to ERP are disabled.');
		var monthlyTargetTitle = $translate.instant('Monthly target: ');
		var weeklyTargetTitle = $translate.instant('Weekly target: ');

		var service = {
			title: title,
			currency: currency,
			integer: integer,
			integerZeroIfEmpty: integerZeroIfEmpty,
			integerWithLink: integerWithLink,
			decimal: decimal,
			dateRenderer: dateRenderer,
			relativeDate: relativeDate,
			daysOffset: daysOffset,
			daysOffsetPositiveOnly: daysOffsetPositiveOnly,
			dateTime: dateTime,
			dueDate: dueDate,
			itemCode: itemCode,
			itemSearchItemCode: itemSearchItemCode,
			valueReplacement: valueReplacement,
			statusWithCircle: statusWithCircle,
			status: statusWithCircle,
			percent: percent,
			hyperLink: hyperLink,
			openModal: openModal,
			firstPurchaseOrder: firstPurchaseOrder,
			firstPurchaseOrderErpStatus: firstPurchaseOrderErpStatus,
			firstPurchaseOrderExceptionMsg: firstPurchaseOrderExceptionMsg,
			firstPurchaseOrderReScheduleDate: firstPurchaseOrderReScheduleDate,
			firstCriticalWeek: firstCriticalWeek,
			firstCriticalMonth: firstCriticalMonth,
			firstCriticalDay: firstCriticalDay,
			bucket: bucket,
			hyperlinkShortage: hyperlinkShortage,
			receivedDate: receivedDate,
			inlineEdit: inlineEdit,
			inlineEditDate: inlineEditDate,
			inlineEditWithoutTooltip: inlineEditWithoutTooltip,
			inlineEditList: inlineEditList,
			inventoryActionSavingsInlineEdit: inventoryActionSavingsInlineEdit,
			leadTime: leadTime,
			daysNoConversion: daysNoConversion,
			excessAtOtherSites: excessAtOtherSites,
			purchaseOrderDeliveryStatus: purchaseOrderDeliveryStatus,
			mainColumnHyperLink: mainColumnHyperLink,
			inventoryActionDetailHyperLink: inventoryActionDetailHyperLink,
			yesNo: yesNo,
			yesNoSSOActive: yesNoSSOActive,
			sboInlineDate: sboInlineDate,
			sboInlineStatus: sboInlineStatus,
			sboInlineColor: sboInlineColor,
			sboInlineList: sboInlineList,
			perfRenderer: perfRenderer,
			inventoryActionsRenderer: inventoryActionsRenderer,
			targetInventoryRenderer: targetInventoryRenderer,
			deltaPerformanceRenderer: deltaPerformanceRenderer,
			daysUntilPOFirmRenderer: daysUntilPOFirmRenderer,
			projectNameRenderer: projectNameRenderer,
			projectStageRenderer: projectStageRenderer,
			projectDueDateRenderer: projectDueDateRenderer,
			projectManagerRenderer: projectManagerRenderer,
			avgPeriodicDemand: avgPeriodicDemand,
			targetQtyRenderer: targetQtyRenderer,
			ppvRenderer: ppvRenderer,
			onOrderNextXDays: onOrderNextXDays,
			onOrderValue: onOrderValue,
			shortageOnOrderQuantity: shortageOnOrderQuantity,
			potentialToSell: potentialToSell,
			uiBootstrapTooltip: uiBootstrapTooltip,
			ytdProjectSavingsRenderer: ytdProjectSavingsRenderer,
			ytdProjectSavingsDeltaRenderer: ytdProjectSavingsDeltaRenderer,
			taskPriority: taskPriority,
			onHand: onHand,
			earlyDeliveries: earlyDeliveries,
			buyerLogin: buyerLogin,
			nonzeroCurrencyRenderer: nonzeroCurrencyRenderer,
			spendSummaryIdentifierRenderer: spendSummaryIdentifierRenderer,
			factorySpendRenderer: factorySpendRenderer,
			inlineAssessmentEdit: inlineAssessmentEdit,
			assessmentQuestion: assessmentQuestion,
			buyerCode: buyerCode,
			orderIntervalByOrderPolicyRenderer: orderIntervalByOrderPolicyRenderer,
			lotSizeRenderer: lotSizeRenderer,
			inlineTaskDueDate: inlineTaskDueDate,
			inlineTaskList: inlineTaskList,
			inlineTaskComment: inlineTaskComment,
			blankForNone: blankForNone,
			shortageCriticalityLevel: shortageCriticalityLevel,
			lateDeliveryIssue: lateDeliveryIssue,
			lastMonthDeliveryPerformance: lastMonthDeliveryPerformance,
			clearSpendSummaryHeaderMap: clearSpendSummaryHeaderMap,
			forecastDelivery: forecastDelivery,
			emailAddressToUserPage: emailAddressToUserPage,
			emailContent: emailContent,
			auditLogContent: auditLogContent,
			futurePPVRenderer: futurePPVRenderer,
			startCase: startCase,
			poConfirmationStatus: poConfirmationStatus,
			poPlacementTime: poPlacementTime,
			viewMetricDataAction: viewMetricDataAction,
			spendAnalyticsIdentifierRenderer: spendAnalyticsIdentifierRenderer,
			strategicGoalRenderer: strategicGoalRenderer,
			analyticsSpendRenderer: analyticsSpendRenderer,
			supplyOrderImpactingShortageRenderer: supplyOrderImpactingShortageRenderer,
			clearToBuildPriorityRenderer: clearToBuildPriorityRenderer,
			poRecommendationRenderer: poRecommendationRenderer,
			conditionsRenderer: conditionsRenderer,
			checkboxRenderer: checkboxRenderer,
			actionCategoryRenderer: actionCategoryRenderer,
			metricValueRenderer: metricValueRenderer,
			inlineMetricComment: inlineMetricComment,
			personNameRenderer: personNameRenderer,
			emailAddressRenderer: emailAddressRenderer,
			lastAccessRenderer: lastAccessRenderer,
			convertDate: convertDate,
			categoryRenderer: categoryRenderer,
			metricRenderer: metricRenderer,
			targetActualRenderer: targetActualRenderer,
			targetActualHeaderRenderer: targetActualHeaderRenderer,
			valueStreamReportCardRenderer: valueStreamReportCardRenderer,
			minmaxLevelRenderer: minmaxLevelRenderer,
			minmaxEffectiveDateRenderer: minmaxEffectiveDateRenderer,
			projectTypeRenderer: projectTypeRenderer,
			projectSavingsCategoryRenderer: projectSavingsCategoryRenderer,
			projectAreaRenderer: projectAreaRenderer,
			projectAreaTargetRenderer: projectAreaTargetRenderer,
			configSSOActionRenderer: configSSOActionRenderer,
			resolveSupplierNdxs: resolveSupplierNdxs,
			projectCategoryRenderer: projectCategoryRenderer,
			workbenchNonCompliantPoRenderer: workbenchNonCompliantPoRenderer,
			commitDateCoverageRenderer: commitDateCoverageRenderer,
			shortageRootCauseCategory: shortageRootCauseCategory,
			shortageRootCauseComment: shortageRootCauseComment,
			weekBucketDates: weekBucketDates,
			confirmationStatusUsed: confirmationStatusUsed,
			reportingPeriodRenderer: reportingPeriodRenderer,
			poIdentifier: poIdentifier,
			isBlanketOrder: isBlanketOrder,
			isMoveInForRequirement: isMoveInForRequirement,
			aggregateRiskScoreRenderer: aggregateRiskScoreRenderer,
			ctbImpactedOrdersRenderer: ctbImpactedOrdersRenderer
		};

		return service;

		function title(row, col, rowIndex, params) {
			var val = row[col.id];
			var classString = 'cell-div ';
			if (params.lastIndex && rowIndex == params.lastIndex) {
				classString += 'footer ';
			}
			var rawHtml = '<div class="' + classString + '"';
			if (val) {
				rawHtml += ' title="' + val + '">' + val;
			} else {
				rawHtml += '>';
			}
			rawHtml += '</div>';
			return rawHtml;
		}

		function convertToCurrency(row, col, params, val) {
			var decimals = row['decimals'];
			var keepAllDecimals = col['keepAllDecimals'];
			decimals = numberOfDecimals(val, decimals, keepAllDecimals);
			if (decimals == 1) decimals = 2;
			if (!keepAllDecimals && (val > 10 || val < -10)) {
				decimals = 0;
			}
			if (val || val == 0) {
				var ldf = row.leanDirFactoryNdx || row.factoryNdx;
				if (ldf && params.conversionFactorBySite && params.conversionFactorBySite[ldf]) {
					val = val * params.conversionFactorBySite[ldf];
				}
				var val = currencyFormatService.getWithParametersNegativeSign(val, decimals, params.currencySymbol);
				return val;
			}
			return val;
		}


		function currency(row, col, rowIndex, params) {
			var val = row[col.id];
			val = convertToCurrency(row, col, params, val);
			var classString = 'class="cell-div ';
			if (params.lastIndex && rowIndex == params.lastIndex) {
				classString += 'footer ';
			}
			if (val || val == 0) {
				classString += 'shift-right " ';
				return '<div ' + classString + ' title="' + val + '">' + val + '</div>';
			} else {
				classString += ' " ';
			}
			return '<div ' + classString + '></div>';
		}

		function integerRender(formattedVal, rowIndex, params) {
			var classString = 'class="cell-div ';
			if (params.lastIndex && rowIndex == params.lastIndex) {
				classString += 'footer ';
			}
			classString += 'shift-right';
			classString += '" ';
			return '<div ' + classString + '  title="' + formattedVal + '">' + formattedVal + '</div>';
		}

		function integer(row, col, rowIndex, params) {
			var formattedVal = convertInteger(row[col.id]);
			return integerRender(formattedVal, rowIndex, params);
		}

		function integerWithLink(row, col, rowIndex, params) {
			var formattedVal = convertInteger(row[col.id]);
			var classString = 'class="cell-div ';
			var disableLink = false;
			if (params.lastIndex && rowIndex == params.lastIndex) {
				classString += 'footer ';
			}
			classString += 'shift-right';
			classString += '" ';


			if (col.disableLinkForEmptyOrZero) {
				if (formattedVal === '' || formattedVal === '0') {
					disableLink = true;
				}
			}

			var url = col.ndxField && row[col.ndxField] && !disableLink
				? col.urlGenerator(col.id, row[col.ndxField], row['factoryNdxs'], row)
				: '';
			var display = url ? '<a href="' + url + '" target="_blank">' + formattedVal + '</a>' : formattedVal;
			return '<div ' + classString + '  title="' + formattedVal + '">' + display + '</div>';
		}

		function integerZeroIfEmpty(row, col, rowIndex, params) {
			var formattedVal = convertInteger(row[col.id]) || 0;
			return integerRender(formattedVal, rowIndex, params);
		}


		function decimal(row, col, rowIndex, params) {
			var decimals = row['decimals'];
			var multiplier = col['multiplier'] || 1;
			var val = row[col.id] * multiplier;
			var keepAllDecimals = col['keepAllDecimals'];
			decimals = numberOfDecimals(val, decimals, keepAllDecimals);
			var formattedVal = val;
			if (decimals || decimals == 0) {
				formattedVal = $filter('number')(val, decimals);
			}
			if (!formattedVal || formattedVal == '0') {
				formattedVal = '';
			}
			return '<div class="cell-div shift-right" title="' + formattedVal + '">' + formattedVal + '</div>';
		}


		function convertInteger(val, noDecimals) {
			var decimals = 0;
			if (!val && val !== 0) {
				return '';
			}
			if (val < 10 && val > -10 && !(typeof noDecimals !== 'undefined' && noDecimals)) {
				decimals = numberOfDecimals(val, decimals, false);
			}
			var formattedVal = val;
			if (decimals || decimals == 0) {
				formattedVal = $filter('number')(val, decimals);
			}
			if (!(formattedVal || formattedVal == 0)) {
				formattedVal = '';
			}
			return formattedVal;
		}

		function convertBusinessToCalendarDays(businessDays) {
			var calendarDays = businessDays / 5 * 7;
			// convert multiples of 4 weeks to multiples of 30
			if (calendarDays % 28 == 0) {
				calendarDays = calendarDays / 28 * 30;
			}
			return calendarDays;
		}

		function addDays(date, numDays) {
			var tmp = new Date(date);
			return new Date(tmp.setDate(date.getDate() + numDays));
		}

		function daysOffset(row, col, rowIndex, params) {
			var cellValue = row[col.id];
			if (shouldMaskDate(cellValue)) {
				return '';
			}
			var formattedValue = '';
			var firstDayInShortage = moment(cellValue);
			var now = moment();
			var formattedValue = now.diff(firstDayInShortage, 'days');
			if (col.addDay) {
				formattedValue += 1;
			}
			return '<div class="cell-div shift-right" title="' + formattedValue + '">' + formattedValue + '</div>';
		}

		function daysOffsetPositiveOnly(row, col, rowIndex, params) {
			var cellValue = row[col.id];
			if (shouldMaskDate(cellValue)) {
				return '';
			}
			var formattedValue = '';
			var firstDayInShortage = moment(cellValue);
			var now = moment();
			var formattedValue = now.diff(firstDayInShortage, 'days') + 1;
			if (formattedValue < 0) {
				formattedValue = '';
			}
			return '<div class="cell-div" title="' + formattedValue + '">' + formattedValue + '</div>';
		}

		function relativeDate(row, col, rowIndex, params) {
			var cellValue = row[col.id];
			if (shouldMaskDate(cellValue)) {
				return '<div class="cell-div"></div>';
			}
			var m = moment(cellValue);
			var relativeValue = m.fromNow();
			var formattedValue = m.format('YYYY-MM-DD');
			return '<div class="cell-div" title="' + formattedValue + '">' + relativeValue + '</div>';
		}

		function dateRenderer(row, col, rowIndex, params) {
			return dateTimeFormat(row, col, params, 'mediumDate');
		}

		function purchaseOrderDeliveryStatus(row, col, rowIndex, params) {
			var deliveryStatus = row['deliveryStatus'];
			switch (deliveryStatus) {
			case 'Delivered - Late':
			case 'Open - Behind Schedule':
				return '<div class="cell-div red" title="Delivery was late">' + deliveryStatus + '</div>';
			case 'Delivered - Early':
				return '<div class="cell-div yellow" title="Delivery was too early">' + deliveryStatus + '</div>';
			default:
				return '<div class="cell-div" title="' + deliveryStatus + '">' + deliveryStatus + '</div>';
			}
		}

		function confirmationStatusUsed(row, col, rowIndex, params) {
			var confirmationStatusUsed = row.confirmationStatusUsed || row.firstPurchaseOrderDateStatus;
			if (typeof confirmationStatusUsed === 'undefined') { // this is only possible in SBI and SBO
				return params.reportName === 'shortagesByOrder' ? '<div class="cell-div"></div>' : noOpenPOsCellContent(row);
			}
			return '<div class="cell-div" title="' + confirmationStatusUsed + '">' + confirmationStatusUsed + '</div>';
		}

		function receivedDate(row, col, rowIndex, params) {
			var actualReceiptDate = parseInt(row[col.id]),
				deliveryStatus = row['deliveryStatus'],
				classes = '',
				title,
				formattedReceiptDate;
			if (!actualReceiptDate || actualReceiptDate > new Date('9990-01-01').getTime()) {
				return '<div class="cell-div" title=""></div>';
			}

			formattedReceiptDate = convertDate(row, col, 'mediumDate', col.id);
			title = formattedReceiptDate;
			switch (deliveryStatus) {
			case 'Open - Behind Schedule':
				title = 'Incomplete delivery, behind schedule ' + formattedReceiptDate;
				classes = 'red';
				break;
			case 'Delivered - Late':
				title = 'Delivery was late - ' + formattedReceiptDate;
				classes = 'red';
				break;
			case 'Delivered - Early':
				title = 'Delivery was too early - ' + formattedReceiptDate;
				classes = 'yellow';
				break;
			default:
				title = formattedReceiptDate;
			}
			return '<div class="cell-div ' + classes + '" title="' + title + '">' + formattedReceiptDate + '</div>';
		}

		function lastMonthDeliveryPerformance(row, col, rowIndex, params) {
			var decimal = row[col.id];
			var classString = 'class="cell-div ';
			var factoryNdxs = row.identifier === 'TOTAL' ? leanFilterService.getSelectedIds('factory') : row.leanDirFactoryNdxs.split(',');
			var hasMixOfTypes = hasMixOfDeliveryPeformanceTypes(factoryNdxs);
			if (params.lastIndex && rowIndex == params.lastIndex) {
				classString += 'footer" ';
			} else {
				classString += ' " ';
			}
			if (decimal == undefined || decimal == '') {
				return '<div ' + classString + '></div>';
			}
			if (hasMixOfTypes) {
				var titleAttr = $translate.instant('Cannot show combined score for this row.  The sites combined on this row use different calculation methods for determining the delivery performance score.');
				return '<div ' + classString + ' title="' + titleAttr + '" translate>N/A</div>';
			}
			var percent = decimal * 100;
			var integerPercent = convertInteger(percent) + '%';
			var drilldownParams = {
				dashboardType: 'Buyer Performance'
			};
			var content, url = undefined;
			if (params.viewType === 'itemGroup') {
				drilldownParams.factory = leanFilterService.getSelectedIds('factory');
				drilldownParams.itemGroupNdx = row['identifier'] === 'TOTAL' ? leanFilterService.getSelectedIds('itemGroupNdx') : row['identifierDisplay'];
				url = addQueryParam(URLS.frontendPrefix + 'dashboard/byType?drilldown=1', null, drilldownParams, false);
			} else if (params.viewType === 'site') {
				drilldownParams.factory = row.identifier === 'TOTAL' ? leanFilterService.getSelectedIds('factory') : row.leanDirFactoryNdxs;
				url = addQueryParam(URLS.frontendPrefix + 'supply-chain/performance-summary/last-month-performance/?drilldown=1', null, drilldownParams, false);
			}
			var display = url ? '<a href="' + url + '" target="_blank">' + integerPercent + '</a>' : integerPercent;

			return '<div ' + classString + ' title="' + integerPercent + '">' + display + '</div>';
		}

		function percent(row, col, rowIndex, params) {
			var decimal = row[col.id];
			var classString = 'class="cell-div shift-right';
			if (params.lastIndex && rowIndex == params.lastIndex) {
				classString += 'footer" ';
			} else {
				classString += ' " ';
			}
			if (!decimal && decimal !== 0) {
				return '<div ' + classString + '></div>';
			}
			var percent = decimal * 100;
			var integerPercent = convertInteger(percent);
			return '<div ' + classString + ' title="' + integerPercent + '%">' + integerPercent + '% </div>';
		}

		function convertSqlDateToJsDate(sqlDate, doUtc, removeTimezoneOffset) {
			if (doUtc) {
				var dt = new Date(sqlDate);
				var parts = sqlDate.split('-');
				return new Date(Date.UTC(parts[0], parts[1], parts[2]));
			} else {
				if (removeTimezoneOffset) {
					return moment(new Date(sqlDate)).subtract(new Date().getTimezoneOffset()).valueOf();
				}
				return new Date(sqlDate);
			}
		}

		//Used to mark overdue projects red. Placed here because this check has to be done for every column
		function dueDate(row, col, rowIndex, params) {
			var displayDate = convertDate(row, col, 'mediumDate', col.id);
			// TODO this needs to be looked at, it appears that even if this made a UTC date,
			// it's always comparing a current moment() which would be local against it
			var jsDate = moment(convertDate(row, col, 'yyyy-MM-dd', col.id));
			var statusColumn = col.statusColumn ? col.statusColumn : 'status';
			var overDue = isOverdueDate(col, jsDate, row[statusColumn], col.statusForCheckingPastDue);
			var cellColor = '';
			if (overDue) {
				cellColor = 'red';
			}
			return '<div class="cell-div ' + cellColor + '" title="' + displayDate + '">' + displayDate + '</div>';
		}

		function isOverdueDate(col, dueDate, status, statusForCheckingPastDue) {
			if (status === 'Completed' || dueDate === '') {
				return false;
			}
			if (statusForCheckingPastDue && statusForCheckingPastDue.length && !_.includes(statusForCheckingPastDue, status)) {
				return false;
			}
			return moment().isAfter(dueDate, 'day');
		}

		function isDateLate(momentDate) {
			if (typeof momentDate === 'undefined') {
				return false;
			}
			var momentNow = moment().startOf('day');
			return (momentDate.startOf('day') < momentNow);
		}

		function shouldMaskDate(cellValue) {
			return typeof cellValue == 'undefined'
				|| cellValue == ''
				|| cellValue == '9999-01-01'
				|| cellValue == '1970-01-01'
				|| cellValue >= new Date('9998-01-01').getTime()
				|| cellValue <= new Date('1971-01-01').getTime();
		}

		function convertDate(row, col, format, id) {
			var formattedValue = '';
			if (shouldMaskDate(row[id])) {
				return '';
			}
			if (col.convertTimeZone) {
				formattedValue = $filter('date')(row[id], format, 'UTC');
			} else {
				formattedValue = $filter('date')(row[id], format);
			}
			if (!formattedValue || formattedValue == 'Jan 1, 9999') {
				formattedValue = '';
			}
			return formattedValue;
		}

		function dateTime(row, col, rowIndex, params) {
			return dateTimeFormat(row, col, params, 'medium');
		}

		function dateTimeFormat(row, col, params, format) {
			var formattedValue = '';
			if (row[col.id] != '') {
				formattedValue = convertDate(row, col, format, col.id);
			}
			return '<div class="cell-div" title="' + formattedValue + '">' + formattedValue + '</div>';
		}

		function shortageRootCauseCategory(row, col, rowIndex, params) {
			var value = $translate.instant(row[col.id]);
			if (!value) value = '';
			return '<div class="cell-div" title="' + value + '">' + value + '</div>';
		}

		function shortageRootCauseComment(row, col, rowIndex, params) {
			var value = $translate.instant(row[col.id]);
			if (!value) value = '';
			return '<div class="cell-div" title="' + value + '">' + value + '</div>';
		}

		function itemCode(row, col, rowIndex, params) {
			var descId = 'itemDescription';
			var itemCode = strip(row[col.id]);
			var itemDesc = strip(row[descId]);
			if (itemDesc) {
				itemDesc = ' : ' + itemDesc;
			} else {
				itemDesc = ' ';
			}
			itemDesc = itemDesc.replace(/"/g, '&quot;');
			var sections = params.defaultTab || 'stockSection';
			var itemType = params['itemType'] || col.itemType;
			var slideInParam = getSlideInParams(rowIndex, sections, itemType, params, row);

			var content;
			var dataTestId = 'data-testclass="reportRow-itemCode-hlink"';
			if (globalConfig.user.role !== 'Supplier') {
				if (params.specificTaskType === 'action') {
					content = '<a ng-href ' + dataTestId + ' class="anchor-link" ng-click="vm.openSlideIn(' + slideInParam + ', \'action\', ' + row.actionId + ', undefined, ' + (row.taskId ? row.taskId: 'undefined') + ', undefined, undefined, true)">' + itemCode + '</a>' + itemDesc;
				} else if (params.specificTaskType === 'task') {
					content = '<a ng-href ' + dataTestId + ' class="anchor-link" ng-click="vm.openSlideIn(' + slideInParam + ', \'task\', ' + row.taskId + ', undefined, ' + (row.taskId ? row.taskId: 'undefined') + ', undefined, undefined, true)">' + itemCode + '</a>' + itemDesc;
				} else {
					content = '<a ng-href ' + dataTestId + ' class="anchor-link" ng-click="vm.openSlideIn(' + slideInParam + ')">' + itemCode + '</a>' + itemDesc;
				}

			} else {
				content = itemCode + itemDesc;
			}

			if (!authorize(['supplyChain', 'itemDrilldown'])) {
				content = itemCode + itemDesc;
			}
			var ldf = row.leanDirFactoryNdx || row.factoryNdx;
			if (ldf && ldf.length) {
				var ldfArray = ldf.toString().split(',');
				if (ldfArray.indexOf(globalConfig.factory.id.toString()) < 0 && !params.multiFactory) content = itemCode + itemDesc;
			}
			var title = itemCode + itemDesc;
			var extra = '';

			return '<div class="cell-div " title="' + title + ' ">' + content + extra + ' ' + '</div>';
		}

		function itemSearchItemCode(row, col, rowIndex, params) {
			var itemCode = strip(row[col.id]);
			var content;
			if (globalConfig.user.role !== 'Supplier') {
				content = '<a ng-href class="anchor-link" ng-click="vm.openItemSearchSlideIn(' + rowIndex + ')">' + itemCode + '</a>';
			} else {
				content = itemCode;
			}

			if (!authorize(['supplyChain', 'itemDrilldown'])) {
				content = itemCode;
			}
			return '<div class="cell-div " title="' + itemCode + ' ">' + content + '</div>';
		}

		function historyIcon(ngClickHistory) {
			return '<div class="historyIcon">' +
				'<ng-include src="\'/application/library/ui_images/svg_icons/history-circle.svg\'" title="Click to see history" ng-click="' + ngClickHistory + '"></ng-include>' +
				'</div>';
		}
		function editIcon(ngClickEdit) {
			return '<div class="editIcon">' +
				'<i class="fa fa-pencil" title="Click to edit"' + ngClickEdit + '></i>' +
				'</div>';
		}

		function valueReplacement(row, col, rowIndex) {
			var replacementValue = col.replacementMap[row[col.id]];
			var finalValue = replacementValue !== undefined ? replacementValue : row[col.id];
			return '<div class="cell-div" title="' + finalValue + '">' + finalValue + '</div>';
		}

		/**
		 * Count of active/recent tasks for the multi-task status badge.
		 * Prefer taskCount (procurement only) so inventory actions are not mixed into Angular Task Status
		 * after React add-task refresh. Fall back to actionCount, then Pattern B list fields.
		 */
		function getRowActionCount(row, params) {
			// IA status column is one row per inventory action — never show a multi-task badge there.
			if (params && params.specificTaskType === 'action') {
				return 0;
			}
			// View / Opportunities Angular reports: taskCount is procurement-only (isSystemGenerated = 0).
			if (row.taskCount != null && row.taskCount !== '' && !isNaN(Number(row.taskCount))) {
				return Number(row.taskCount);
			}
			if (row.actionCount != null && row.actionCount !== '' && !isNaN(Number(row.actionCount))) {
				return Number(row.actionCount);
			}
			if (row.taskIds) {
				return String(row.taskIds).split(',').map(function (part) {
					return part.trim();
				}).filter(Boolean).length;
			}
			var ndx = row.actionStatusNdx;
			if (ndx != null && ndx !== '') {
				if (typeof ndx === 'number') {
					return 1;
				}
				return String(ndx).split(',').map(function (part) {
					return part.trim();
				}).filter(Boolean).length;
			}
			// Some Pattern B views only expose GROUP_CONCAT status names (e.g. Spend, Procurement history).
			var statusNames = row.actionStatus;
			if (typeof statusNames === 'string' && statusNames.indexOf(', ') >= 0) {
				return statusNames.split(', ').map(function (part) {
					return part.trim();
				}).filter(Boolean).length;
			}
			if (row.numTasks) {
				var numTasks = Number(row.numTasks);
				if (!isNaN(numTasks) && numTasks >= 0) {
					return numTasks;
				}
			}
			if (row.taskId || row.actionNdx || (statusNames && statusNames !== 'None')) {
				return 1;
			}
			return 0;
		}

		function statusWithCircle(row, col, rowIndex, params) {
			var status = row[col.id];
			var ngClick;
			var rowId = params.specificTaskType === 'action' ? row.actionId : row.taskId;
			var actionCount = getRowActionCount(row, params);
			var rowMaxCap = 9;

			// Multi-task badge (same behavior as React ActionStatusRenderer)
			if (status && status !== 'None' && actionCount > 1) {
				var badgeLabel = actionCount > rowMaxCap ? rowMaxCap + '+' : String(actionCount);
				var multiSlideInParams = [
					rowIndex,
					'\'opportunitiesSection\'',
					params.itemType || 'undefined',
					"'" + (row.leanDirFactoryNdx || row.factoryNdx) + "'",
					params.specificTaskType ? "'" + params.specificTaskType + "'" : 'undefined',
					rowId || 'undefined',
					'undefined',
					row.taskId || 'undefined',
					'undefined',
					'undefined',
					'true',
					'true'
				].join(', ');
				return '<div class="cell-div action-multi-task-cell" data-testclass="action-status-multi-task"'
					+ ' ng-click="$event.stopPropagation();vm.openSlideIn(' + multiSlideInParams + ')"'
					+ ' title="View all tasks">'
					+ '<span class="action-multi-task-field">' + badgeLabel + '</span>'
					+ '</div>';
			}

			if (status === null || typeof status === 'undefined' || status === 'None') {
				status = 'None';
				ngClick = 'vm.addTask(' + rowIndex + (params.specificTaskType ? ', \'' + params.specificTaskType + '\'' : '') + ')';
			} else if (typeof status === 'string' && status.indexOf(', ') >= 0) {
				// Rolled-up GROUP_CONCAT list — show the primary (first) status for the single-task path.
				status = status.split(', ')[0];
			}
			var statusSlug = $filter('slugify')(status);
			var activeStatus = row['actionIsActive'] === false ? 'archived' : 'active';
			var title = getTitleForStatus(status, row['actionIsActive']);
			if (row['actionIsActive'] === false) {
				status = 'Archived (' + status + ')';
			}
			var slideInParams = [
				rowIndex,
				'\'opportunitiesSection\'', // sections
				params.itemType || 'undefined',
				"'" + (row.leanDirFactoryNdx || row.factoryNdx) + "'",
				params.specificTaskType ? "'"+params.specificTaskType+"'" : 'undefined',
				rowId || 'undefined', // task or action id,
				'undefined',
				row.taskId || 'undefined'
			].join(', ');
			if (!ngClick) {
				ngClick = 'vm.openSlideIn(' + slideInParams + ')';
			}
			var canEdit = false;
			var ndxKey = undefined;
			if (params.specificTaskType === 'action') {
				canEdit = row.actionId && (status === 'Open' || status === 'Unable to Fix' || status === 'Review Later');
				ndxKey = 'iaStatusNdx';
			} else {
				canEdit = row.taskId && status.indexOf('Archived') < 0;
				ndxKey = 'actionStatusNdx';
			}
			var inlineEditClick = !canEdit ? '' : '<div class="inlineActionIcons"><i title="Click to edit" class="fa fa-pencil" ' +
				'ng-click="$event.stopPropagation();vm.startEditList(' + rowIndex + ',\'' + col.id + '\', \'' + status + '\', \'' + ndxKey + '\')"></i></div>';
			var display = status === 'None' ? 'Add Task' : status;
			if (display === 'Review Later') {
				display = 'In Progress';
			}
			var cellContent = canEdit ? '<div class="edit-name-text with-status">' + display + '</div>' + inlineEditClick : '<span>' + display + '</span>';
			return '<div class="cell-div ' + (canEdit ? 'inline-edit-cell ' : '') + 'task-status-' + statusSlug
				+ ' task-status-' + activeStatus
				+ '" ng-click="' + ngClick
				+ '" title="' + title + '">'
				+ cellContent
				+ '</div>';
		}

		function getPlannedSupplyDisplay(row) {
			if (typeof row.isSplitPo !== 'undefined' && row.isSplitPo) {
				return SPLIT_PO_MESSAGE;
			}
			var formattedValue = $filter('number')(row.plannedOnOrderQuantity, numberOfDecimals(row.plannedOnOrderQuantity, 0, false));
			if (!formattedValue) {
				return 'No Supply';
			}
			return formattedValue + ' ' + row.unitOfMeasure + ' Planned';
		}

		function hasNoOpenPOs(row) {
			return row.firstPurchaseOrder === '' || row.firstPurchaseOrder === '-' || row.firstPurchaseOrder === 'No Open PO\'s' || !row.firstPurchaseOrder;
		}

		function hasNoReceipts(row, col) {
			if (col.id.endsWith('MasterSupplier') || (globalConfig.user.role == 'Supplier' && col.id === 'lastReceivedSupplierName')) {
				return row.lastReceivedQtyMasterSupplier === '' || !row.lastReceivedQtyMasterSupplier;
			}
			return row.lastReceivedQty === '' || !row.lastReceivedQty;
		}

		function renderChatWithContent(chatEnabled, rowIndex, params, content, row) {
			var lastActivity = '';
			var fullLastActivtyTime = '';
			if (chatEnabled) {
				var poNumber = row.firstPurchaseOrderNumber || row.supplyOrderNumber || row.purchaseOrderNumber || row.orderNumber;
				var poLine = row.firstPurchaseOrderLine || row.orderLine || row.purchaseOrderLine;
				var scheduleLine = row.firstPurchaseOrderScheduleLine || row.scheduleLine;
				var identifier = '';
				if (poNumber) {
					identifier = row.itemNdx + ':' + poNumber + ':' + poLine + ':' + scheduleLine;
				}

				if(row['chatLastActivityString']) {
					lastActivity = row['chatLastActivityString'];
				} else if (row['chatLastActivity']) {
					lastActivity = storeService.dateUtils.getShortRelativeDate(row['chatLastActivity']);
					fullLastActivtyTime = 'title="' + storeService.dateUtils.getFormattedDate(row['chatLastActivity'], 'PPpp') + '"';
				}


				var chatIconHolderClass = 'empty';
				if(row['chatWatchedByCurrentUser']) {
					chatIconHolderClass += ' watched';
				}
				if(typeof row['chatStatus'] === 'string') {
					chatIconHolderClass = chatIconHolderClass + ' ' + row['chatStatus'];
				}
			}

			var reportName = params.reportName ? '\'' + params.reportName + '\'': params.reportName;
			var chatRender = '<div class="chatCellContainer" ng-click="vm.openItemDrilldown(' + rowIndex +', '+ reportName +', \'openChat\')"><button type="button" class="chatIconButton">' +
				'<div class="chatIconHolder ' + chatIconHolderClass + '"><ng-include src="\'/application/library/ui_images/svg_icons/chat-icon-filled.svg\'"></ng-include></div>' +
				'<div class="chatIconText" ' + fullLastActivtyTime + '>' + lastActivity + '</div>' +
			'</button><span class="chatCellContent">' + content + '</span></div>';
			return chatEnabled ? chatRender : content;
		}

		function noOpenPOsCellContent(row) {
			var displayText = getPlannedSupplyDisplay(row);
			var hoverCellValue = displayText;
			if (row.plannedOnOrderQuantity) {
			// Have planned supply, provide link to supply report with filter for planned supply (and item code)
				var drilldownHyperLink = getShortageHyperLink('plannedOnOrderQuantity', row);
				if (drilldownHyperLink) {
					hoverCellValue = '<a href="' + drilldownHyperLink + '" target="_blank">' + hoverCellValue + '</a>';
				}
			}
			return '<div class="cell-div invalidHighlight grayCell" title="' + displayText + '"><div class="hoverShowCell">' + hoverCellValue + '</div></div>';
		}

		function noReceiptsCellContent(row) {
			return '<div class="cell-div invalidHighlight grayCell" title ="No Receipts"><div class="hoverShowCell">No Receipts</div></div>';
		}

		// Used in shortageByItem
		function firstPurchaseOrder(row, col, rowIndex, params) {
			if (col.id.startsWith('lastReceived') && hasNoReceipts(row, col)) {
				return noReceiptsCellContent(row);
			}

			if ((col.id.includes('firstPurchaseOrder') || col.id === 'firstErpPoNotes') && hasNoOpenPOs(row)) {
				return noOpenPOsCellContent(row);
			}

			if (col.id === 'firstPurchaseOrder') {
				var purchaseOrderQtyString = row.firstPurchaseOrderQty || '';
				var unitOfMeasureString = row.unitOfMeasure;
				var contentString = row.firstPurchaseOrder +
					' (' + purchaseOrderQtyString + ' ' + unitOfMeasureString + ')';
				return '<div class="cell-div invalidHighlight" title ="' + contentString + '">' + renderChatWithContent(isChatEnabled, rowIndex, params, contentString, row) + '</div>';
			} else if (col.id === 'firstPurchaseOrderQty') {
				var purchaseOrderQtyString = row.firstPurchaseOrderQty;
				return '<div class="cell-div invalidHighlight shift-right" title ="' + purchaseOrderQtyString + '">'+ purchaseOrderQtyString + '</div>';
			} else if (col.id.startsWith('lastReceivedQty')) {
				return authorize(['supplyChain', 'purchaseOrderReceipts'])
					? hyperlinkShortage(row, col, rowIndex, params)
					: decimal(row, col, rowIndex, params);
			} else if (col.id.endsWith('SupplierName') || col.id === 'firstErpPoNotes') {
				var value = strip(row[col.id]);
				if (globalConfig.user.role == 'Supplier' && col.id === 'lastReceivedSupplierName') {
					value = strip(row['supplierName'] || '');
				}
				return '<div class="cell-div" title ="' + value + '">'+ value + '</div>';
			} else if (col.id.includes('Date')) {
				return dateTimeFormat(row, col, params, 'mediumDate');
			}
		}

		function firstPurchaseOrderErpStatus(row, col, rowIndex, params) {
			if (hasNoOpenPOs(row)) {
				return noOpenPOsCellContent(row);
			}
			var firstPoErpStatus = strip(row.firstPurchaseOrderErpStatus) || '';
			return '<div class="cell-div invalidHighlight" title ="' + firstPoErpStatus + '">' + firstPoErpStatus + '</div>';
		}

		function firstPurchaseOrderExceptionMsg(row, col, rowIndex, params) {
			if (hasNoOpenPOs(row)) {
				return noOpenPOsCellContent(row);
			}
			var firstPoExceptionMsg = strip(row.firstPurchaseOrderExceptionMsg) || '';
			return '<div class="cell-div invalidHighlight" title ="' + firstPoExceptionMsg + '">' + firstPoExceptionMsg + '</div>';
		}

		function firstPurchaseOrderReScheduleDate(row, col, rowIndex, params) {
			if (hasNoOpenPOs(row)) {
				return noOpenPOsCellContent(row);
			}
			var firstPoReScheduleDate = row.firstPurchaseOrderReScheduleDate ?
				$filter('date')(row.firstPurchaseOrderReScheduleDate, 'mediumDate', 'UTC') : '';
			return '<div class="cell-div invalidHighlight" title ="' + firstPoReScheduleDate + '">' + firstPoReScheduleDate + '</div>';
		}

		// Used in shortageByItem
		function firstCriticalWeek(row, col, rowIndex, params) {
			var functionString = getCriticalityDate(row, col, params, 'week');
			return '<div class="cell-div " title="' + functionString + '">' + functionString + '</div>';
		}

		function firstCriticalMonth(row, col, rowIndex, params) {
			var functionString = getCriticalityDate(row, col, params, 'month');
			return '<div class="cell-div " title="' + functionString + '">' + functionString + '</div>';
		}

		function firstCriticalDay(row, col, rowIndex, params) {
			var functionString = getCriticalityDate(row, col, params, 'day');
			return '<div class="cell-div" title="' + functionString + '">' + functionString + '</div>';
		}

		function getCriticalityDate(row, col, params, type) {
			var lastUpdate = moment(row.lastUpdate).utc();
			if (row.firstCriticalBucket == 0) {
				return 'Current';
			}
			if (row.firstCriticalBucket == -1 || !row.firstCriticalBucket || row.firstCriticalBucket == 9999) {
				return 'None';
			} else if (type == 'day') {
				return $filter('date')(lastUpdate.add(row.firstCriticalBucket, 'days').toDate(), 'MMM d, y', 'UTC') || 'None';
			} else if (type == 'week') {
				return weekBucketDates(lastUpdate, row.firstCriticalBucket, row.fixedWeekBucketOffset) || 'None';
			} else {
				lastUpdate.add(1, 'd');
				return $filter('date')(lastUpdate.add(row.firstCriticalBucket - 1, 'M').toDate(), 'MMM yyyy', 'UTC') || 'None';
			}
		}

		function weekBucketDates(lastUpdate, bucketNum, fixedWeekBucketOffset) {
			var intervalStart = lastUpdate.clone().add({weeks: bucketNum - 1}).add({days: fixedWeekBucketOffset });
			var intervalEnd = intervalStart.clone().add({days: 6});
			var sameMonth = intervalStart.month() === intervalEnd.month();
			var sameYear = intervalStart.year() === intervalEnd.year();
			var nextYear = intervalStart.diff(lastUpdate.clone().add({years: 1})) > 0;
			var intervalStartString = $filter('date')(intervalStart.toDate(), 'MMM d', 'UTC');
			var intervalEndString = $filter('date')(intervalEnd.toDate(), 'd', 'UTC');
			if (sameYear && !sameMonth && !nextYear) {
				intervalStartString = $filter('date')(intervalStart.toDate(), 'MMM d', 'UTC');
				intervalEndString = $filter('date')(intervalEnd.toDate(), 'MMM d', 'UTC');
			}
			if (sameYear && !sameMonth && nextYear) {
				intervalStartString = $filter('date')(intervalStart.toDate(), 'MMM d', 'UTC');
				intervalEndString = $filter('date')(intervalEnd.toDate(), 'MMM d, y', 'UTC');
			}
			if (sameYear && sameMonth && nextYear) {
				intervalStartString = $filter('date')(intervalStart.toDate(), 'MMM d', 'UTC');
				intervalEndString = $filter('date')(intervalEnd.toDate(), 'd, y', 'UTC');
			}
			if (!sameYear && !sameMonth) {
				intervalStartString = $filter('date')(intervalStart.toDate(), 'MMM d, y', 'UTC');
				intervalEndString = $filter('date')(intervalEnd.toDate(), 'MMM d, y', 'UTC');
			}
			return intervalStartString + ' - ' + intervalEndString;
		}

		function bucket(row, col, rowIndex, params) {
			var val = convertInteger(row[col.id]);
			var criticalBucket = row['firstCriticalBucket'];
			if (col.id == 'reqmtToday') {
				var classFunction = '';
				if (criticalBucket == 0) {
					classFunction = 'red';
				}
				var titleFunction = '';
				if (classFunction == 'red') {
					titleFunction = 'This part is currently short';
				} else {
					titleFunction = val;
				}
			} else if (col.id.substring(0, 6) === 'bucket') {
				var positive = row['bucket' + col.bucketNum + 'quantity'] >= 0;
				var classFunction = getClassForShortageBucket(row['bucket' + col.bucketNum + 'criticality'], criticalBucket, col.bucketNum);
				var titleFunction = getHoverTextForShortageBucket(row['bucket' + col.bucketNum + 'criticality'], classFunction, positive);
			} else if (col.id.substring(0, 5) === 'month') {
				var positive = row['month' + col.monthNum + 'quantity'] >= 0;
				var classFunction = getClassForShortageBucket(row['month' + col.monthNum + 'criticality'], criticalBucket, col.monthNum);
				var titleFunction = getHoverTextForShortageBucket(row['month' + col.monthNum + 'criticality'], classFunction, positive);
			} else {
				var positive = row['day' + col.bucketNum + 'quantity'] >= 0;
				var classFunction = getClassForShortageBucket(row['day' + col.bucketNum + 'criticality'], criticalBucket, col.bucketNum);
				var titleFunction = getHoverTextForShortageBucket(row['day' + col.bucketNum + 'criticality'], classFunction, positive);
			}
			return '<div class="cell-div shift-right ' + classFunction + '" title="' + titleFunction + '">' + val + '</div>';
		}

		function getClassForShortageBucket(criticality, criticalBucket, num) {
			if (!criticality || criticality === '') {
				return '';
			}
			var classCriticalityMap = {
				'MinMaxWarning': 'orange',
				'Critical': 'red',
				'Warning': 'yellow',
				'CheckPastDue': 'orange',
				'ClearToBuildWarning': 'orange',
				'None': ''
			};
			var coloring = classCriticalityMap[criticality];
			if (coloring == 'red' || coloring == 'orange') {
				if (num < criticalBucket) {
					return '';
				}
			}
			return coloring;
		}

		function getHoverTextForShortageBucket(criticality, classFunction, isPositive) {
			if (!criticality || criticality === '') {
				return '';
			}
			if (isPositive && criticality === 'Critical') {
				criticality = 'CriticalWithPositive';
			}
			var hoverTextCriticalityMap = {
				'MinMaxWarning': 'Potential shortage for a Min Max item. The shortage is within lead time.',
				'Critical': 'Critical shortage expected, and you are already inside the lead time window.',
				'Warning': 'On hand quantity less than safety stock',
				'CheckPastDue': 'Requirements for this period cannot be satisfied unless past due purchase orders are delivered. Check past due orders to ensure that they will arrive on time to cover this potential shortage.',
				'None': '',
				'CriticalWithPositive': 'Critical shortage expected in the middle of this period, and you are already inside the lead time window.',
				'ClearToBuildWarning': 'Requirements for this period cannot be satisfied unless a purchase order is delivered in the LOB supply exclusion window.'
			};
			return hoverTextCriticalityMap[criticality];
		}


		function hyperlinkShortage(row, col, rowIndex, params) {
			var url = getShortageHyperLink(col.id, row);
			var content = row[col.id] + '';
			if (col.id === 'analysisAvgDailyDemandFloat' || col.id === 'analysisAvgMonthlyDemandFloat') {
				content = $filter('number')(content, numberOfDecimals(content, 2, false));
			}
			if (col.id === 'totalOnHandUnrestrictedQuantity' || col.id === 'totalOnHandBlocked' ||
				col.id === 'totalOnOrderQuantityFloat' || col.id === 'totalOnHandQuantityFloat' ||
				col.id === 'plannedOnOrderQuantity' || col.id === 'firmedOnOrderQuantity' ||
				col.id === 'totalOnHandConsignmentQuantity' || col.id.startsWith('lastReceivedQty')) {
				content = $filter('number')(content, numberOfDecimals(content, 0, false));
				var uom = '';
				if (row.unitOfMeasure) {
					uom = ' ' + row.unitOfMeasure;
				} else if (row.purchasingUOM) {
					uom = ' ' + row.purchasingUOM;
				}
				content = content + uom;
			}

			if (((globalConfig.user.role == 'Supplier' || !authorize(['supplyChain', 'reports']))
			&& (col.id === 'analysisAvgDailyDemandFloat'
				|| col.id === 'analysisAvgMonthlyDemandFloat'
				|| col.id === 'totalOnHandUnrestrictedQuantity'
				|| col.id === 'totalOnHandQuantityFloat'
				|| col.id === 'totalOnHandConsignmentQuantity'))
			|| !url) {
				return '<div class="cell-div shift-right">' +
				content + '</div>';
			}
			return '<div class="cell-div shift-right">' +
			'<a href="' + url + '" target="_blank">' + content + '</a>' +
			'</div>';
		}

		function getProjectHyperLink(projNdx, type, factoryId, extraNdx, viewLink) {
			if (!factoryId) factoryId = globalConfig.factory.id;
			var link = viewLink + projNdx + '&factoryNdx=' + factoryId;
			if (type === 'task') {
				link += '&taskNdx=' + extraNdx;
			}
			return link;
		}

		function getSitesWithCTBNestedSearchEnabled(){
			var currentCustomerSites = Object.keys(
				globalConfig.user.authFacts
			).filter(function (site) {
				return (
					globalConfig.user.authFacts[site].customerNdx ===
          globalConfig.customer.id
				);
			});
			return currentCustomerSites.filter(function (site) {
				return (
					globalConfig.user.authFacts[site].settings &&
          globalConfig.user.authFacts[site].settings
            .IncludingNestedSearchInCTB === '1'
				);
			});
		}

		function ctbImpactedOrdersRenderer(row, col, rowIndex, params){
			var url = getClearToBuildDrilldownLink(row, row.factoryNdx, col.id);
			var content;
			if(col.id === 'ctbImpactedOrdersSingleShortageCount'){
				content = row.ctbImpactedOrdersSingleShortageCount;
			} else {
				content = row.ctbShortageImpactedValue ? convertToCurrency(row, col, params, row.ctbShortageImpactedValue): null;
			}
			var showLink =
      content &&
      getSitesWithCTBNestedSearchEnabled().includes(
      	row.factoryNdx.toString()
      );
			if(showLink){
				return '<div class="cell-div shift-right">' +
				'<a href="' + url + '" target="_blank">' + content + '</a>' +
				'</div>';
			} else if (content){
				return '<div class="cell-div shift-right">' + content + '</div>';
			}
			return '<div class="cell-div shift-right"></div>';
		}

		function getClearToBuildDrilldownLink(row, factoryNdx, colId) {
			var drilldownSearch = {
				id: 'parentAssemblyNestedSearch',
				operator: 'eq',
				value: row.itemCode,
				searchType: 'NESTED_ITEM'
			};
			var drilldownFilters = [
				drilldownFunctionsService.makeSelectFilter('factory', [factoryNdx]),
				drilldownFunctionsService.makeSelectFilter('clearToBuildProgress', ['INDIVIDUAL_REQS_LATE', 'INDIVIDUAL_REQS_NO_SUPPLY'])
			];
			if(colId === 'ctbImpactedOrdersSingleShortageCount'){
				drilldownFilters.push(drilldownFunctionsService.makeRangeFilter('missingPurchasedItemCount', leanFilterService.comparatorsMap.equal, 1));
			}
			if(colId === 'ctbImpactedOrdersSingleShortageManufacturedCount'){
				drilldownFilters.push(drilldownFunctionsService.makeRangeFilter('missingManufacturedItemCount', leanFilterService.comparatorsMap.equal, 1));
			}
			var drilldownBaseUrl = '/application/f/home.html#/supply-chain/clear-to-build/multi-level';
			return drilldownBaseUrl + drilldownFunctionsService.makeDrilldownParamString(drilldownFilters, false, null, drilldownSearch);
		}

		function getReactPurchaseRequisitionsDrilldownLink(row, factoryNdx) {
			var drilldownSearch = row.fullItemCode;
			var drilldownFilters = [
				drilldownFunctionsService.makeSelectFilter('factory', [factoryNdx]),
				drilldownFunctionsService.makeRangeFilter('remainingQuantityFloat', leanFilterService.comparatorsMap.greaterThan, 0)
			];
			var drilldownBaseUrl = '/application/f/home.html#/supply-chain/purchase-requisitions';
			return drilldownBaseUrl + drilldownFunctionsService.makeDrilldownParamString(drilldownFilters, false, null, drilldownSearch);
		}

		function getShortageHyperLink(type, row) {
			var itemType = row.itemType ? row.itemType : 'Purchased';
			var isManufactured = itemType !== 'Purchased';
			var factoryNdx = row.leanDirFactoryNdx || row.factoryNdx;
			var isSupplier = globalConfig.user.role == 'Supplier';
			if (type.startsWith('lastReceivedQty')) {
				return drilldownFunctionsService.getReportDrilldownUrl('supply-chain/purchase-order-receipts', null,
					{
						search: row.fullItemCode,
						factory: factoryNdx
					},
					true
				);
			} else if ((type === 'analysisAvgDailyDemandFloat' || type === 'analysisAvgMonthlyDemandFloat') && !isSupplier) {
				var drilldownSearch = row.fullItemCode;
				var drilldownFilters = [
					drilldownFunctionsService.makeSelectFilter('factory', [factoryNdx])
				];
				return '/application/f/home.html#/supply-chain/requirements/weekly-requirements' + drilldownFunctionsService.makeDrilldownParamString(drilldownFilters, false, null, drilldownSearch);
			} else if ((type === 'totalOnHandUnrestrictedQuantity' || type === 'totalOnHandConsignmentQuantity') && !isSupplier) {
				return drilldownFunctionsService.getReportDrilldownUrl(
					isManufactured ? 'supply-chain/inventory/manufactured-inventory' : 'supply-chain/inventory/purchased-inventory/',
					null,
					{
						state: 'Unrestricted',
						search: row.fullItemCode,
						factory: factoryNdx
					},
					true
				);
			} else if (type === 'totalOnHandQuantityFloat' && !isSupplier) {
				return drilldownFunctionsService.getReportDrilldownUrl(
					isManufactured ? 'supply-chain/inventory/manufactured-inventory' : 'supply-chain/inventory/purchased-inventory/',
					null,
					{
						search: row.fullItemCode,
						factory: factoryNdx
					},
					true
				);
			} else if (type === 'totalOnOrderQuantityFloat' && !isSupplier) {
				var url = drilldownFunctionsService.getReportDrilldownUrl('supply-chain/supply-orders', null, {
					reactParams: {
						filters: [
							drilldownFunctionsService.makeRangeFilter('remainingQuantityFloat', leanFilterService.comparatorsMap.greaterThan, 0),
							drilldownFunctionsService.getMinimalFilterFromReportSettings({id: 'documentType', unselectedValues: ['Purchase Requisition']}),
							drilldownFunctionsService.makeSelectFilter('factory', [factoryNdx])
						],
						search: row.fullItemCode
					},
					search: row.fullItemCode,
					onOrderValueOne: 0,
					onOrderComparator: 'gt',
					factory: factoryNdx
				}, true);
				return url + '&isOnOrderDrilldown=true';
			} else if (type === 'plannedOnOrderQuantity') {
				var isPurchasedItems = itemType === 'Purchased';
				var report = isPurchasedItems ? 'purchase-requisitions' : 'supply-orders';

				var additionalParam = '';
				if (!row.plannedOnOrderDocumentTypes) {
					// use previously set value
				}	else if (row.plannedOnOrderDocumentTypes.includes(',')) {
					report = 'supply-orders';
					additionalParam = '&documentType=' + encodeURIComponent('Purchase Requisition,Planned Production Order');
				} else if (row.plannedOnOrderDocumentTypes === 'Planned Production Order') {
					report = 'planned-production-orders';
				} else if (row.plannedOnOrderDocumentTypes === 'Purchase Requisition'){
					report = 'purchase-requisitions';
				}

				if (report === 'purchase-requisitions' && !authorize(['supplyChain', 'purchaseRequisitions'])) {
					return null;
				}
				if (report === 'purchase-requisitions') {
					return getReactPurchaseRequisitionsDrilldownLink(row, factoryNdx);
				}

				if (isSupplier && ['planned-production-orders', 'supply-orders'].indexOf(report) !== -1) {
					return null;
				}

				return '/application/f/home.html#/supply-chain/' + report + '?drilldown=1' +
					'&search=' + row.fullItemCode + '&onOrderValueOne=0&onOrderComparator=gt&factory=' + factoryNdx + additionalParam;
			} else if (type === 'firmedOnOrderQuantity' && !isSupplier) {
				return drilldownFunctionsService.getReportDrilldownUrl('supply-chain/supply-orders', null, {
					reactParams: {
						filters: [
							drilldownFunctionsService.makeRangeFilter('remainingQuantityFloat', leanFilterService.comparatorsMap.greaterThan, 0),
				      drilldownFunctionsService.getMinimalFilterFromReportSettings({id: 'documentType', unselectedValues: ['Purchase Requisition', 'Planned Production Order']}),
				      drilldownFunctionsService.makeSelectFilter('factory', [factoryNdx])
						],
						search: row.fullItemCode
					},
					search: row.fullItemCode,
					onOrderValueOne: 0,
					onOrderComparator: 'gt',
					factory: factoryNdx
				}, true);
			} else if (type === 'totalOnHandBlocked' && !isSupplier) {
				return drilldownFunctionsService.getReportDrilldownUrl(
					isManufactured ? 'supply-chain/inventory/manufactured-inventory' : 'supply-chain/inventory/purchased-inventory/',
					null,
					{
						state: 'Blocked',
						search: row.fullItemCode,
						factory: factoryNdx
					},
					true
				);
			}
		}

		function hyperLink(row, col, rowIndex, params) {
			var linkName = row[col.id];
			var url;
			if (col.type === 'project' || col.type === 'task') {
				url = getProjectHyperLink(row['projNdx'], col.type, row.leanDirFactoryNdx || row.factoryNdx, row['taskNdx'], params.viewLink);
			} else if (col.type === 'metric') {
				url = params.viewLink + row['ndx'];
			}
			return '<div class="cell-div " title="' + linkName + '">  <a href="' + url + '">' + linkName + '</a> </div>';
		}

		function openModal(row, col, rowIndex, params) {
			var value = row[col.id];
			var openModalFunction = col.openModalFunctionName;
			return '<div class="cell-div " title="' + value + '">  <a class="ldnaLink" ng-click="vm.' + openModalFunction + '(' + rowIndex + ')">' + value + '</a> </div>';
		}

		function excessAtOtherSites(row, col, rowIndex, params) {
			var sections = 'multitenantSection';
			var val = row[col.id];
			val = convertInteger(val, true);
			if (val == 0 || typeof val === 'undefined') {
				val = '';
			}
			if (globalConfig.user.role === 'Supplier') {
				return '<div class="cell-div shift-right" title="" >' + val + '</div>';
			}

			var slideInParam = getSlideInParams(rowIndex, sections, params['itemType'], params, row);
			return '<div class="cell-div shift-right" title="" >' +
				'<a ng-href class="anchor-link" ng-click="vm.openSlideIn(' + slideInParam + ')">' + val + '</a></div>';
		}

		function leadTime(row, col, rowIndex, params) {
			var val = '';
			if (row[col.id] === undefined) {
				val = '';
			} else {
				var rawValue = row[col.id];
				var siteId = row.leanDirFactoryNdx || row.factoryNdx;
				var daysDisplayType = globalConfig.user.authFacts[siteId].daysDisplayType;
				if (daysDisplayType !== 'Calendar Days') {
					val = integerFormatService.getWithParameters(rawValue / 7 * 5, 0, true) + ' Work Days';
				} else {
					val = convertInteger(rawValue);
					val = val + ' Days';
				}
			}
			return '<div class="cell-div" title="' + val + '">' + val + '</div>';
		}

		function daysNoConversion(row, col, rowIndex, params) {
			var rawValue = row[col.id];
			var val = rawValue >= 0 &&	integerFormatService.getWithParameters(rawValue, 0, true) || '';
			return '<div class="cell-div" title="' + val + '">' + val + '</div>';
		}

		function aggregateRiskScoreRenderer(row, col, rowIndex, params){
			var val = row.aggregateRiskScore;
			if(val && val > 0){
				var ndxColumn = 'aggregateRiskScore';
				var rowNdx = row.ndx || row.orderNdx || row.itemNdx;

				var html;
				var label = 'Risk Scores';
				var tooltipString = 'vm.getTooltip(\'' + ndxColumn + '\',' + rowNdx + ')';
				var show = 'vm.showIt(\'' + ndxColumn + '\' , ' + rowNdx + ' , \'' + col.id + '\' ,\'' + label + '\',' + rowIndex + ', \'riskScores\')';
				var hide = 'vm.hideIt(\'' + ndxColumn + '\', ' + rowNdx + ' , \'' + col.id + '\')';

				var coloringClass = '';
				if (val >= 8) {
					coloringClass = 'red';
				} else if (val >= 5 && val < 8) {
					coloringClass = 'orange';
				} else if (val > 0 && val < 5) {
					coloringClass = 'yellow';
				}

				html = '<div class="cell-div shift-right '+ coloringClass + '" id="' + col.id + rowNdx + '">' +
					'<div class="edit-name-text ng-binding" uib-tooltip-html="' + tooltipString + '" ' +
					'tooltip-trigger="none" tooltip-is-open="vm.tooltipIsReady(\'' + ndxColumn + '\',' + rowNdx + ')" tooltip-animation="false" tooltip-placement="{{ vm.tooltipPlacements[\'' + col.id + rowIndex + '\'] || \'auto left\' }}"' +
					'tooltip-append-to-body="true" ng-mouseenter="' + show + '" ng-mouseleave="' + hide + '"' + '> ' +
					'<div class="name-field">' + val + '</div>' +
					'</div>' +
					'</div>';
				return html;
			} else {
				return '<div class="cell-div shift-right" title="' + val + '">' + val + '</div>';
			}
		}

		function inlineEdit(row, col, rowIndex, params) {
			var editType = col.editType;
			var maxInputLength = col.maxInputLength;
			var ndxColumn, allowCommentString, cannotEditDisplay;
			var rowNdx = row.ndx || row.partialPoNdx || row.orderNdx;
			var label = 'Status';
			var bucketType = params['bucketType'];
			var isSplitPo = typeof row.isSplitPo !== 'undefined' && row.isSplitPo;
			if (editType === 'poComment') {
				if (col.checkTmq && row['isTmq']) {
					if (col.id === 'firstPoStatus') {
						return sboTmqInlineStatus(row, col, rowIndex, params);
					}
				}
				allowCommentString = row.firstPurchaseOrderNumber || row.partialPoNdx || row.supplyOrderNumber || row.purchaseOrderNumber;
				allowCommentString = !!allowCommentString && !isSplitPo;
				if (col.id === 'lateDeliveryDescription') {
					ndxColumn = 'lateDeliveryIssueCommentNdx';
					label = 'Late Delivery Cause';
				} else if (col.id === 'poStatusCategoryDescription') {
					var poNumber = row.firstPurchaseOrderNumber || row.purchaseOrderNumber || row.supplyOrderNumber;
					var poLine = row.firstPurchaseOrderLine || row.orderLine || row.purchaseOrderLine;
					var scheduleLine = row.firstPurchaseOrderScheduleLine || row.scheduleLine;
					ndxColumn = 'poStatusCategoryCommentNdx';
					label = 'Supply Order Status Category';
					var deliveryStatus = row['deliveryStatus'];
					if (poNumber === undefined || poLine === undefined || scheduleLine === undefined) {
						allowCommentString = false;
						cannotEditDisplay = 'No PO Associated.';
					}
				} else {
					ndxColumn = 'firstPoStatusNdx';
					if (col.id === 'firstPoTrackingNumber') {
						ndxColumn = 'firstPoTrackingNumberNdx';
						label = 'Tracking Number';
					}
					if (['shortageByItem', 'lineOfBalance'].indexOf(params.reportName) > -1 && hasNoOpenPOs(row)) {
						return noOpenPOsCellContent(row);
					}
					cannotEditDisplay = getPlannedSupplyDisplay(row);
				}
			}
			if (allowCommentString) {
				var content = '';
				var nameFieldClass = '';
				var cellClass = '';
				var editHtml = '';
				var actionIconsHtml = '';
				var tooltipString = 'vm.getTooltip(\'' + ndxColumn + '\',' + rowNdx + ')';
				var show = 'vm.showIt(\'' + ndxColumn + '\' , ' + rowNdx + ' , \'' + col.id + '\' ,\'' + label + '\',' + rowIndex + ', \'userComment\')';
				var hide = 'vm.hideIt(\'' + ndxColumn + '\', ' + rowNdx + ' , \'' + col.id + '\')';
				var ngClickEdit;
				if (col.id === 'lateDeliveryDescription' || col.id === 'poStatusCategoryDescription') {
					ngClickEdit = ' ng-click="vm.startEditList(' + rowIndex + ', \'' + col.id + '\', \'Status\')"';
				} else {
					if (maxInputLength === undefined) {
						ngClickEdit = ' ng-click="vm.startEdit(' + rowIndex + ',\'' + col.id + '\', \'' + (col.id === 'firstPoTrackingNumber' ? 'Tracking Number' : 'Status') + '\')"';
					} else {
						ngClickEdit = ' ng-click="vm.startEdit(' + rowIndex + ',\'' + col.id + '\', \'' + (col.id === 'firstPoTrackingNumber' ? 'Tracking Number' : 'Status') + '\', undefined, ' + maxInputLength + ')"';
					}
				}

				var clickHistory = 'vm.showStatusHistory(' + rowIndex + ', \'' + editType + '\',\'' + bucketType + '\'' + ({
					'lateDeliveryDescription': ',\'lateDeliveryDescription\'',
					'poStatusCategoryDescription': ',\'poStatusCategoryDescription\'',
					'firstPoTrackingNumber': ',\'firstPoTrackingNumber\''
				}[col.id] || '') + ')';

				if (row[col.id] != null) {
					content = strip(row[col.id]);
					content = content.replace(/\"/g, '&quot;');
					cellClass += ' with-history';
					editHtml = editIcon(ngClickEdit);
					actionIconsHtml = '<div class="inlineActionIcons" id="actionIcons">' +
						historyIcon(clickHistory) +
						'</div>';
				} else {
					nameFieldClass += ' emptyContent';
				}

				return '<div class="cell-div invalidHighlight inline-edit-cell" id="' + col.id + rowNdx + '">' +
					'<div class="edit-name-text' + cellClass + ' ng-binding"  id="inlineStatus" uib-tooltip-html="' + tooltipString + '" ' +
					'tooltip-trigger="none" tooltip-is-open="vm.tooltipIsReady(\'' + ndxColumn + '\',' + rowNdx + ')" tooltip-animation="false" tooltip-placement="{{ vm.tooltipPlacements[\'' + col.id + rowIndex + '\'] || \'auto left\' }}"' +
					'tooltip-append-to-body="true" ng-mouseenter="' + show + '" ng-mouseleave="' + hide + '"' + ngClickEdit + '> ' +
					'<div class="name-field' + nameFieldClass + '">' + content + '</div>' +
					editHtml +
					'</div>' +
					actionIconsHtml +
					'</div>';
			} else {
				var cannotEditTooltip = cannotEditDisplay;
				if (isSplitPo) {
					cannotEditDisplay = strip(row[col.id] || '').replace(/\"/g, '&quot;');
					cannotEditTooltip = SPLIT_PO_MESSAGE;
				}
				return '<div class="cell-div invalidHighlight grayCell" id="' + col.id + rowNdx + '" title="' + cannotEditTooltip + '">' +
					'<div class="hoverShowCell">' + cannotEditDisplay + '</div>' +
					'</div>';
			}
		}

		function inlineEditDate(row, col, rowIndex, params) {
			if (col.checkTmq && row['isTmq'] && col.id === 'firstPoEcdDate') {
				var colDefinition = _.cloneDeep(col);
				colDefinition.ndxKey = 'firstPoEcdNdx';
				colDefinition.columnId = 'soCommitDateCopy';
				colDefinition.commentType = 'userComment';
				return sboInlineDate(row, colDefinition, rowIndex, params);
			}
			var allowCommentString = row.firstPurchaseOrderNumber || row.purchaseOrderNumber || row.supplyOrderNumber;
			if (!allowCommentString) {
				return noOpenPOsCellContent(row);
			}
			var isSplitPo = typeof row.isSplitPo !== 'undefined' && row.isSplitPo;
			var rowNdx = row.ndx || row.partialPoNdx || row.orderNdx;
			var column = 'firstPoEcd';
			var nameFieldClass = '';
			var tooltipString = '';
			var tooltipHtml = 'vm.getTooltip(\'firstPoEcdNdx\',' + rowNdx + ')';
			var content = '';
			var jsDate;
			var nearOverDue = false;
			var overDue = false;
			var markColor = '';
			var cellClass = '';
			var editHtml = '';
			var wrapperClass = 'cell-div invalidHighlight';
			var ngClickEdit = '';
			var show = 'vm.showIt(\'firstPoEcdNdx\' , ' + rowNdx + ' , \'' + col.id + '\' ,\'Commit Date\', ' + rowIndex + ', \'userComment\')';
			var hide = 'vm.hideIt(\'firstPoEcdNdx\', ' + rowNdx + ' , \'' + col.id + '\')';
			if (isSplitPo) {
				wrapperClass += ' grayCell';
				tooltipString = SPLIT_PO_MESSAGE;
			}
			if (row[column]) {
				content = $filter('date')(row[column], 'mediumDate');
				jsDate = convertSqlDateToJsDate(row[column], col.convertTimeZone, col.removeTimezoneOffset);
				nearOverDue = isOverdueDate(col, jsDate, row.firstPoStatus);
				overDue = isOverdueDate(col, moment(jsDate).add(1, 'day'), row.firstPoStatus);
				if (nearOverDue && !overDue) {
					markColor = ' yellow';
				}
				else if (overDue) {
					markColor = ' red';
					cellClass += ' overDue';
				}
			} else {
				nameFieldClass += ' emptyContent';
			}

			if (!isSplitPo) {
				ngClickEdit = ' ng-click="vm.startEditDate(' + rowIndex + ',\'' + col.id + '\', ' + col.showApprovalModal + ')"';
				editHtml = editIcon(ngClickEdit);
				wrapperClass += ' inline-edit-cell';
				cellClass = 'edit-name-text' + cellClass;
				tooltipString = content;
			}
			wrapperClass += markColor;

			return '<div class="' + wrapperClass + '" id="firstPoEcd' + rowNdx + '">' +
				'<div class="' + cellClass + ' ng-binding" title="' + tooltipString + '" uib-tooltip-html="' + tooltipHtml + '" ' +
				'tooltip-trigger="none" tooltip-is-open="vm.tooltipIsReady(\'firstPoEcdNdx\',' + rowNdx + ')" tooltip-animation="false" tooltip-placement="left"' +
				'tooltip-append-to-body="true" ng-mouseenter="' + show + '" ng-mouseleave="' + hide + '"' + ngClickEdit + '>' +
				'<div class="name-field' + nameFieldClass + '">' + content + '</div>' +
				editHtml +
				'</div>' +
				'</div>';

		}

		function inlineEditWithoutTooltip(row, col, rowIndex, params) {
			var val = row[col.id];
			if (col.id === 'productionRate') {
				if (!val && val !== 0) val = 1;
				val = numberFormatService.getWithParameters(val, 2) + ' units / minute';
			}
			if (col.requiredPermission) {
				var hasPrivileges;
				if (col.requiredPermission === 'adminOrUser') {
					hasPrivileges= $rootScope.authz.isAdmin() || row.userNdx == globalConfig.user.id;
				}
				if (col.requiredPermission === 'admin') {
					hasPrivileges= $rootScope.authz.isAdmin();
				}
				if (!hasPrivileges) return '<div class="cell-div" title="' + val + '">' + val + '</div>';
			}
			var label = col.editLabel || 'Edit ' + col.display;
			var inputType = col.inputType;
			var inputTypeHTML = inputType ? "'" + inputType + "'" : 'undefined';
			var maxLength = col.maxLength;
			var maxLengthHTML = maxLength ? "'" + maxLength + "'" : 'undefined';
			var deleteHTML = col.deleteFunction
				?  '<i title="Delete row"  ng-click="vm.' + col.deleteFunction + '(' + rowIndex + ')"  class="fa fa-trash"></i>'
				: '';
			var withDeleteClassHTML = col.deleteFunction ? ' with-delete' : '';
			var controllerName = params && params.controllerName;
			var controllerNameHTML = controllerName ? "'" + controllerName + "'" : 'undefined';
			var editFunction = col.editFunction || 'startEdit';
			return '<div class="cell-div inline-edit-cell">' +
				'<div class="edit-name-text' + withDeleteClassHTML + '" title="' + val + '">' + val + '</div>' +
				'<div class="inlineActionIcons' + withDeleteClassHTML + '" id="actionIcons">' +
				'<i class="fa fa-pencil	title="Click to edit" ng-click="vm.' + editFunction + '(' + rowIndex + ',\'' + col.id + '\',\'' + label + '\'' +
				','  + inputTypeHTML + ','  + maxLengthHTML + ',' + controllerNameHTML + ',' + col.allowBlank + ')"></i>' +
				deleteHTML + '</div></div>';
		}

		function inlineEditList(row, col, rowIndex, params) {
			var value = col.isYesNo ? (row[col.id] ? 'Yes' : 'No') : row[col.id] || '';
			if (col.requiredPermission) {
				var hasPrivileges;
				if (col.requiredPermission === 'admin') {
					hasPrivileges = $rootScope.authz.isAdmin();
				}
				if (!hasPrivileges) {
					return '<div class="cell-div" title="' + value + '">' + value + '</div>';
				}
			}
			var ndxKey = col.idField;
			var controllerName = params && params.controllerName;
			var controllerNameHTML = controllerName ? "'" + controllerName + "'" : 'undefined';
			var deleteHTML = col.deleteFunction
				?  '<i title="Delete row"  ng-click="vm.' + col.deleteFunction + '(' + rowIndex + ')"  class="fa fa-trash"></i>'
				: '';
			var withDeleteClassHTML = col.deleteFunction ? ' with-delete' : '';
			var ngClickEdit = ' ng-click="vm.startEditList(' + rowIndex + ',\'' + col.id + '\', undefined, \'' + ndxKey + '\'' + ',' + controllerNameHTML + ')"';
			var editHtml = editIcon(ngClickEdit);
			var grayClass = params.grayClass ? params.grayClass : '';

			var content = '<div class="cell-div inline-edit-cell' + grayClass + '"  id="' + col.id + row.ndx + '">' +
				'<div class="edit-name-text' + withDeleteClassHTML + ' ng-binding" title="' + value + '"' + ngClickEdit + '>' +
				'<div class="name-field">' + value + '</div>' +
				editHtml +
				'</div>' +
				'<div class="inlineActionIcons' + withDeleteClassHTML + '" id="actionIcons">' +
				deleteHTML + '</div></div>';
			return content;
		}

		// Inventory Action Report Specific
		function inventoryActionSavingsInlineEdit(row, col, rowIndex, params) {
			var userPermissions = globalConfig.user.invalidateInventoryActions ||
				$rootScope.authz.isLeanDNAAdmin();
			var allowEditSavings = (row.status === 'Unable to Fix' || row.status === 'Fixed') && userPermissions;
			var rowNdx = row.ndx || row.orderNdx;

			var html;
			var val = row[col.id];
			val = convertToCurrency(row, col, params, val);
			var strikethrough = row.hasValidSavings ? '' : ' linethrough';
			if (!allowEditSavings) {
				var classString = 'class="cell-div shift-right' + strikethrough + '"';
				if (val || val == 0) {
					html = '<div ' + classString + ' title="' + val + '">' + val + '</div>';
				} else {
					html = '<div ' + classString + '></div>';
				}
			} else {
				var ngClickEdit = ' ng-click="vm.startEditList(' + rowIndex + ',\'' + col.id + '\',\'' + val + '\',\'actualSavings\')"';

				html = '<div class="cell-div shift-right inline-edit-cell" id="actualSavings' + rowNdx + '">' +
					'<div class="edit-name-text ng-binding' + strikethrough + '" title="' + val + '"' + ngClickEdit + '>' +
					'<div class="name-field">' + val + '</div>' +
					editIcon(ngClickEdit) +
					'</div>' +
					'</div>';
			}
			return html;
		}

		function getSlideInParams(rowIndex, sections, itemType, params, row) {
			var ret = rowIndex + ', ';
			ret += (sections && sections !== 'undefined' ? "'" + sections + "'": sections);
			if (itemType) {
				ret += ", '" + itemType + "'";
			} else if (params && params.itemType) {
				ret += ", '" + params.itemType + "'";
			} else {
				ret += ', undefined';
			}
			ret += ", '" + (row.leanDirFactoryNdx || row.factoryNdx) + "'";
			return ret;
		}

		function getTitleForStatus(status, actionIsActive) {
			var title;
			if (!status || status === '' || status == 'None') {
				if (globalConfig.user.role === 'Supplier') {
					title = 'No assigned task';
				} else {
					title = 'No task, click to add task';
				}
			} else if (actionIsActive === false) {
				title = 'Task is archived';
			} else {
				var statusDisplay = status === 'Review Later' ? 'In Progress' : status;
				title = 'Task status is ' + statusDisplay + ', click to edit task';
			}
			return title;
		}

		function numberOfDecimals(val, defaultDec, keepAllDecimals) {
			var decimals = defaultDec;
			if (!decimals && decimals !== 0)
				decimals = 2;
			if (keepAllDecimals) {
				var valTmp = '' + val;
				var valSplit = valTmp.split('.');
				if (valSplit && valSplit.length == 2) {
					valTmp = valSplit[1].replace(/0+$/, '');
					return valTmp.length;
				} else {
					return 0;
				}
			}

			var valTmp = val + '';
			if (valTmp.indexOf('.') == -1) {
				return 0;
			}
			if (val == 0) {
				decimals = 0;
			} else if (val < 0.0000001 && val > -0.0000001 && decimals < 9) {
				decimals = 9;
			} else if (val < 0.000001 && val > -0.000001 && decimals < 8) {
				decimals = 8;
			} else if (val < 0.00001 && val > -0.00001 && decimals < 7) {
				decimals = 7;
			} else if (val < 0.0001 && val > -0.0001 && decimals < 6) {
				decimals = 6;
			} else if (val < 0.001 && val > -0.001 && decimals < 5) {
				decimals = 5;
			} else if (val < 0.01 && val > -0.01 && decimals < 4) {
				decimals = 4;
			} else if (val < 0.1 && val > -0.1 && decimals < 3) {
				decimals = 3;
			} else if (val < 1 && val > -1 && decimals < 2) {
				decimals = 2;
			} else if (val < 10 && val > -10 && decimals < 2) {
				// This is to add a number less than 10 to show 2 decimals if it is a decimal number
				var valStr = '' + val;
				var valStrSplit = valStr.split('.');
				if (valStrSplit && valStrSplit.length === 2) {
					valStr = valStrSplit[1].replace(/0+$/, '');
					decimals = Math.min(valStr.length, 2);
				}
			}
			if (val > 10 || val < -10) {
				if (defaultDec == undefined) {
					decimals = 0;
				} else {
					decimals = defaultDec;
				}
			}
			return decimals;
		}

		function yesNo(row, col, rowIndex, params) {
			var shiftRightClassHTML = col.align === 'left' ? '' : ' shift-right';
			var text = row[col.id] ? 'Yes' : 'No';
			return '<div class="cell-div' + shiftRightClassHTML + '" translate>' + text + '</div>';
		}



		//Internal Inventory Action Report Related
		function inventoryActionDetailHyperLink(row, col, rowIndex, params) {
			var hyperlink = '/application/f/home.html#/setup/inventory-action-report/detail?drilldown=1';
			var selectedSites;
			if (params.otherView == 'site') {
				try {
					selectedSites = leanFilterService.getSelectedIds('allFactory');
					if (selectedSites.length === 0) {
						selectedSites = leanFilterService.getFactoryList();
					}
				} catch (TypeError) {
					selectedSites = leanFilterService.getFactoryList();
				}
				hyperlink += '&site=' + selectedSites;
				hyperlink += '&inventoryActionType=' + row.actionType;
			} else {
				hyperlink += '&site=' + (row.leanDirFactoryNdx || row.factoryNdx);
				var action = leanFilterService.getSelectedIds('inventoryActionType');
				if (action.length === 0) {
					action = '';
				}
				hyperlink += '&inventoryActionType=' + action;
			}

			hyperlink += getDateCreated();
			hyperlink += getDateCompleted();
			hyperlink += getActionStatus();
			var extraClass = '';
			var content = row[col.id];
			var cell = '';
			var circle = '';
			if (col.id == 'fixed') {
				extraClass = getExtraClass(row);
				circle = '<div class="leandna-grid-cell-indicator ' + extraClass + '"><i class="fa fa-circle small-circle"></i></div>';
			}
			content = formatInventoryActionValue(row, col, params);
			var id = col.id;
			if (id == 'fixed' || id == 'wontFix' || id == 'invalid' || id == 'open') {
				hyperlink += '&inventoryActionStatus=' + id;
			} else if (id == 'total') {
				hyperlink += '&inventoryActionStatus=LDNA_A_S';
			}
			cell = '<div class="cell-div shift-right">' + circle + '<a href="' + hyperlink + '" target="_blank">' + content + '</a></div>';
			return cell;
		}

		function getDateCreated() {
			var dateCreatedParam = '';

			var dateCreated = leanFilterService.getFilterById('dateCreated');
			if (dateCreated.disabled) {
				dateCreatedParam += '&creationDateValueOne=' + (new Date(dateCreated.valueOne)).getTime();
				if (dateCreated.valueTwo) {
					dateCreatedParam += '&creationDateValueTwo=' + (new Date(dateCreated.valueTwo)).getTime();
				}
				dateCreatedParam += '&creationDateComparator=' + dateCreated.comparator.abbr;
			}
			return dateCreatedParam;
		}

		function getDateCompleted() {
			var dateCompletedParam = '';

			var dateCompleted = leanFilterService.getFilterById('dateCompleted');
			if (dateCompleted.disabled) {
				dateCompletedParam += '&completedDateValueOne=' + (new Date(dateCompleted.valueOne)).getTime();
				if (dateCompleted.valueTwo) {
					dateCompletedParam += '&completedDateValueTwo=' + (new Date(dateCompleted.valueTwo)).getTime();
				}
				dateCompletedParam += '&completedDateComparator=' + dateCompleted.comparator.abbr;
			}
			return dateCompletedParam;
		}

		function getActionStatus() {
			var actionStatusParam = '';
			var inventoryActionStatus = leanFilterService.getFilterById('inventoryActionStatus');
			if (inventoryActionStatus.disabled) {
				actionStatusParam += '&inventoryActionStatus=' + inventoryActionStatus.selectedList.join(',');
			}
			return actionStatusParam;
		}

		function getExtraClass(row) {
			var percentFixed = row.fixed / row.total * 100;
			if (percentFixed < 20) {
				return 'bad-text';
			}
			if (percentFixed < 50) {
				return 'warn-text';
			}
			return 'good-text';
		}

		function formatInventoryActionValue(row, col, params) {
			var id = col.id;
			var value = row[id];
			if (id == 'percentTotalSavings') {
				return (convertInteger(value) * 100) + '%';
			}
			if (id == 'fixed' || id == 'wontFix' || id == 'invalid' || id == 'open' || id == 'total') {
				return convertInteger(value);
			} else {
				return convertToCurrency(row, col, params, value);
			}
		}

		function mainColumnHyperLink(row, col, rowIndex, params) {
			var hyperlink = '/application/f/home.html#/setup/inventory-action-report/' + params.otherView +
				'?drilldown=1';
			switch (params.otherView) {
			case 'site':
				hyperlink += '&inventoryActionType=' + row.actionType;
				break;
			case 'type':
				hyperlink += '&site=' + (row.leanDirFactoryNdx || row.factoryNdx);
				break;
			default:
			//Shouldn't happen
			}
			hyperlink += getDateCreated();
			hyperlink += getDateCompleted();
			hyperlink += getActionStatus();
			return '<div class="cell-div"><a href="' + hyperlink + '" target="_blank">' + row[col.id] + '</a></div>';
		}

		function sboInlineDate(row, col, rowIndex, params) {
			var value = row[col.id];
			var label = col.label || 'Commit Date';
			var commentType = col.commentType || 'comment';
			var tooltipString = 'vm.getTooltip(\'' + col.ndxKey + '\',' + row.ndx + ')';
			var allowCommentString = params.allowInlineEdit;
			var show = 'vm.showIt(\'' + col.ndxKey + '\' , ' + row.ndx + ' , \'' + col.id + '\' ,\'' + label + '\',' + rowIndex + ', \'' + commentType + '\')';
			var hide = 'vm.hideIt(\'' + col.ndxKey + '\', ' + row.ndx + ' , \'' + col.id + '\')';
			var hasContent = true;
			var content = '';
			var nameFieldClass = '';
			var editHtml = '';
			var cellClass = commentType === 'comment' ? ' with-copy' : '';
			var ngClickEdit = allowCommentString ? ' ng-click="vm.startEditDate(' + rowIndex + ',\'' + (col.columnId || col.id) + '\')"' : '';

			if (_.isNumber(value)) {
				value = $filter('date')(value, 'yyyy-MM-dd', 'UTC');
			}

			var momentDate = moment(value, 'YYYY-MM-DD');
			var isOverDue = isDateLate(momentDate);
			var markRed = '';
			var actionIconsHtml = commentType === 'comment'
				? (
					'<div class="inlineActionIcons' + (isOverDue ? ' overDue' : '') + ' with-copy" id="actionIcons">' +
					'<i class="fa fa-copy" title="Click to copy" ng-click="vm.copy(' + rowIndex + ', \'' + col.id + '\')"></i>' +
					'<i class="fa fa-paste" title="Click to paste" ng-click="vm.paste(' + rowIndex + ', \'' + col.id + '\')"></i>' +
					'</div>'
				)
				: '';

			if (isOverDue) {
				markRed = 'red';
				cellClass += ' overDue';
			}

			if (value) {
				content = $filter('date')(value, 'mediumDate');
			} else {
				hasContent = false;
				nameFieldClass += ' emptyContent';
			}

			if (!allowCommentString) {
				cellClass += ' no-edit';
			} else if (hasContent) {
				editHtml = editIcon(ngClickEdit);
			}

			return '<div class="cell-div invalidHighlight inline-edit-cell ' + markRed + '"  id="' + col.id + row.ndx + '">' +
				'<div class="edit-name-text' + cellClass + ' ng-binding" title="' + content + '" uib-tooltip-html="' + tooltipString + '" ' +
				'tooltip-trigger="none" tooltip-append-to-body="true" tooltip-is-open="vm.tooltipIsReady(\'' + col.ndxKey + '\',' + row.ndx + ')"' +
				'tooltip-animation="false" tooltip-placement="auto left"' +
				'ng-mouseenter="' + show + '" ng-mouseleave="' + hide + '"' + ngClickEdit + '>' +
				'<div class="name-field' + nameFieldClass + '">' + content + '</div>' +
				editHtml +
				'</div>' +
				actionIconsHtml +
				'</div>';
		}

		function inlineTaskDueDate(row, col, rowIndex, params) {
			var allowEdit = !!row[col.id];
			var displayDate = convertDate(row, col, 'mediumDate', col.id);
			var jsDate = moment(convertDate(row, col, 'yyyy-MM-dd', col.id));
			var statusColumn = col.statusColumn ? col.statusColumn : 'status';
			var overDue = isOverdueDate(col, jsDate, row[statusColumn], col.statusForCheckingPastDue);
			var markRed = '';
			var ngClickEdit = allowEdit ? ' ng-click="vm.startEditDate(' + rowIndex + ',\'' + col.id + '\')"' : '';
			var cellClass = '';
			var editHtml = '';
			if (overDue) {
				markRed = ' red';
				cellClass += ' overDue';
			}

			if (allowEdit) {
				editHtml = editIcon(ngClickEdit);
			} else {
				cellClass += ' no-edit';
			}

			return '<div class="cell-div invalidHighlight inline-edit-cell' + markRed + '"  id="' + col.id + row.ndx + '">' +
				'<div class="edit-name-text' + cellClass + '" title="' + displayDate + '"' + ngClickEdit + '>' +
				'<div class="name-field">' + displayDate + '</div>' +
				editHtml +
				'</div>' +
				'</div>';
		}

		function blankForNone(row, col, rowIndex, params) {
			var value = row[col.id] === 'None' ? '' : row[col.id];
			return '<div class=" cell-div">' + value + '</div>';

		}

		function inlineTaskList(row, col, rowIndex, params) {
			var value = row[col.id] ? row[col.id] : '';
			if (col.id === 'actionCategory' && value === 'None') {
				value = '';
			}
			var allowEdit = !!value;
			var ngClickEdit = allowEdit ? ' ng-click="vm.startEditList(' + rowIndex + ',\'' + col.id + '\', undefined, \'' + ndxKey + '\')"' : '';
			var cellClass = '';
			var editHtml = '';
			var ndxKey = col.idField;
			var grayCellClass = '';
			var isArchived = row['isActiveCategory'];
			if (col.id === 'actionCategory' && typeof isArchived !== 'undefined' && !isArchived) {
				grayCellClass = 'invalidHighlight grayCell';
				if (value && value !== 'None') {
					value += ' (archived)';
				}
			}

			if (allowEdit) {
				editHtml = editIcon(ngClickEdit);
			} else {
				cellClass += ' no-edit';
			}

			return '<div class="cell-div invalidHighlight inline-edit-cell ' + grayCellClass + '"  id="' + col.id + row.ndx + '">' +
				'<div class="edit-name-text' + cellClass + ' ng-binding" title="' + value + '"' + ngClickEdit + '>' +
				'<div class="name-field">' + value + '</div>' +
				editHtml +
				'</div>' +
				'</div>';
		}

		function inlineTaskComment(row, col, rowIndex, params) {
			var content = strip(row[col.id]);
			if (!content || content === 'undefined') content = '';
			var allowAddComment = !!row.taskId;
			var ndxColumn = 'taskId';
			var rowNdx = row.ndx || row.orderNdx || row.taskId;
			var tooltipString = 'vm.getTooltip(\'' + ndxColumn + '\',' + rowNdx + ')';
			var show = 'vm.showIt(\'' + ndxColumn + '\' , ' + rowNdx + ' , \'' + col.id + '\' ,\'Comment\',' + rowIndex + ', \'taskComment\')';
			var hide = 'vm.hideIt(\'' + ndxColumn + '\', ' + rowNdx + ' , \'' + col.id + '\')';
			var ngClickEdit = allowAddComment ? ' ng-click="vm.startEdit(' + rowIndex + ',\'' + col.id + '\', \'Comment\', undefined, undefined, undefined, false)"' : '';
			// although this cell doesnt have history, but UX decided not to update the styling for this cell.  Using 'with-history' to keep the alignment intact.
			var cellClass = ' with-history';
			var editHtml = '';
			if (allowAddComment) {
				editHtml = '<div class="inlineActionIcons" id="actionIcons">' +
					'<i class="fa fa-plus" title="Click to add comment"' + ngClickEdit + '></i>' +
					'</div>';
			} else {
				cellClass += ' no-edit';
			}
			return '<div class="cell-div invalidHighlight inline-edit-cell"  id="' + col.id + rowNdx + '">' +
				'<div class="edit-name-text' + cellClass + ' ng-binding" uib-tooltip-html="' + tooltipString + '" ' +
				'tooltip-append-to-body="true" ' +
				'tooltip-trigger="none" tooltip-is-open="vm.tooltipIsReady(\'' + ndxColumn + '\',' + rowNdx + ')" tooltip-animation="false" tooltip-placement="auto left"' +
				'ng-mouseenter="' + show + '" ng-mouseleave="' + hide + '"' + ngClickEdit + '>' + content + '</div>' +
				editHtml +
				'</div>';
		}

		function sboTmqInlineStatus(row, col, rowIndex, params) {
			var columnId = 'soStatusCopy';
			var value = row[col.id];
			var maxInputLength = col.maxInputLength;
			var content = '';
			var hasContent = true;
			var commentType = 'userComment';
			var cellClass = '';
			var nameFieldClass = '';
			var ndxKey = 'firstPoStatusNdx';
			var valEscapedQuotes = content.replace(/\"/g, '&quot;');
			var allowCommentString = params.allowInlineEdit;
			var label = 'Status';
			var tooltipString = 'vm.getTooltip(\'' + ndxKey + '\',' + row.ndx + ')';
			var show = 'vm.showIt(\'' + ndxKey + '\' , ' + row.ndx + ' , \'' + col.id + '\' ,\'' + label + '\', ' + rowIndex + ', \'' + commentType + '\')';
			var hide = 'vm.hideIt(\'' + ndxKey + '\', ' + row.ndx + ' , \'' + col.id + '\')';
			var clickHistory = 'vm.sboShowStatusHistory(\'' + rowIndex + '\', \'' + ndxKey + '\', \'' + commentType + '\')';
			var ngClickEdit = allowCommentString ? ' ng-click="vm.startEdit(' + rowIndex + ',\'' + columnId + '\', \'' + label + '\', undefined, ' + maxInputLength + ')"' : '';
			var editHtml = '';
			var actionIconsHtml = '';
			var copyAndPaste = '';

			if (value != null) {
				content = strip(value);
				cellClass += ' with-history';
			} else {
				hasContent = false;
				nameFieldClass += ' emptyContent';
			}

			if (!allowCommentString) {
				cellClass += ' no-edit';
			} else if (hasContent) {
				editHtml = editIcon(ngClickEdit);
				actionIconsHtml = '<div class="inlineActionIcons' + (commentType === 'comment' ? ' with-copy' : '') + '" id="actionIcons">' +
					copyAndPaste +
					historyIcon(clickHistory) +
					'</div>';
			}

			return '<div class="cell-div invalidHighlight inline-edit-cell"  id="' + col.id + row.ndx + '">' +
				'<div class="edit-name-text' + cellClass + ' ng-binding" title="' + valEscapedQuotes + '" uib-tooltip-html="' + tooltipString + '" ' +
				'tooltip-append-to-body="true" ' +
				'tooltip-trigger="none" tooltip-is-open="vm.tooltipIsReady(\'' + ndxKey + '\',' + row.ndx + ')" tooltip-animation="false" tooltip-placement="auto left"' +
				'ng-mouseenter="' + show + '" ng-mouseleave="' + hide + '"' + ngClickEdit + '>' +
				'<div class="name-field' + nameFieldClass + '">' + content + '</div>' +
				editHtml +
				'</div>' +
				actionIconsHtml +
				'</div>';
		}

		function sboInlineStatus(row, col, rowIndex, params) {
			var value = row[col.id];
			var maxInputLength = col.maxInputLength;
			var content = '';
			var hasContent = true;
			var commentType = col.commentType ? col.commentType : 'comment';
			var cellClass = commentType === 'comment' ? ' with-copy' : '';
			var nameFieldClass = '';
			var ndxKey = col.ndxKey;
			var valEscapedQuotes = content.replace(/\"/g, '&quot;');
			var allowCommentString = params.allowInlineEdit;
			var label = col.inlineLabel;
			var tooltipString = 'vm.getTooltip(\'' + ndxKey + '\',' + row.ndx + ')';
			var show = 'vm.showIt(\'' + ndxKey + '\' , ' + row.ndx + ' , \'' + col.id + '\' ,\'' + label + '\', ' + rowIndex + ', \'' + commentType + '\')';
			var hide = 'vm.hideIt(\'' + ndxKey + '\', ' + row.ndx + ' , \'' + col.id + '\')';
			var clickHistory = 'vm.sboShowStatusHistory(\'' + rowIndex + '\', \'' + ndxKey + '\', \'' + commentType + '\')';
			var ngClickEdit = allowCommentString ? ' ng-click="vm.startEdit(' + rowIndex + ',\'' + col.id + '\', \'' + label + '\', undefined, ' + maxInputLength + ')"' : '';
			var editHtml = '';
			var actionIconsHtml = '';
			var copyAndPaste = commentType === 'comment'
				? ('<i class="fa fa-copy" title="Click to copy" ng-click="vm.copy(' + rowIndex + ', \'' + col.id + '\')"></i>' +
					'<i class="fa fa-paste" title="Click to paste" ng-click="vm.paste(' + rowIndex + ', \'' + col.id + '\')"></i>')
				: '';

			if (value != null) {
				content = strip(value);
				cellClass += ' with-history';
			} else {
				hasContent = false;
				nameFieldClass += ' emptyContent';
			}

			if (!allowCommentString) {
				cellClass += ' no-edit';
			} else if (hasContent) {
				editHtml = editIcon(ngClickEdit);
				actionIconsHtml = '<div class="inlineActionIcons' + (commentType === 'comment' ? ' with-copy' : '') + '" id="actionIcons">' +
					copyAndPaste +
					historyIcon(clickHistory) +
					'</div>';
			}

			return '<div class="cell-div invalidHighlight inline-edit-cell"  id="' + col.id + row.ndx + '">' +
				'<div class="edit-name-text' + cellClass + ' ng-binding" title="' + valEscapedQuotes + '" uib-tooltip-html="' + tooltipString + '" ' +
				'tooltip-append-to-body="true" ' +
				'tooltip-trigger="none" tooltip-is-open="vm.tooltipIsReady(\'' + ndxKey + '\',' + row.ndx + ')" tooltip-animation="false" tooltip-placement="auto left"' +
				'ng-mouseenter="' + show + '" ng-mouseleave="' + hide + '"' + ngClickEdit + '>' +
				'<div class="name-field' + nameFieldClass + '">' + content + '</div>' +
				editHtml +
				'</div>' +
				actionIconsHtml +
				'</div>';
		}

		function inlineMetricComment(row, col, rowIndex, params) {
			var value = row[col.id];
			var allowComment = row['resultType'] && row['resultType'] !== 'suspend' && !isNaN(parseInt(row.resultNdx));
			if (!value) value = '';
			var ndxColumn = 'commentNdx';
			var commentNdx = row.commentNdx;
			var label = 'Comment';
			var valEscapedQuotes = value.replace(/\"/g, '&quot;');
			var show = 'vm.showIt(\'' + ndxColumn + '\' , ' + commentNdx + ' , \'' + col.id + '\' ,\'' + label + '\',' + rowIndex + ', \'userComment\')';
			var hide = 'vm.hideIt(\'' + ndxColumn + '\', ' + commentNdx + ' , \'' + col.id + '\')';
			var ngClickEdit = allowComment ? ' ng-click="vm.startEdit(' + rowIndex + ',\'' + col.id + '\', \'Edit Comment\',undefined,undefined,\'' + params.controllerName + '\')"' : '';
			var copyAndPaste = allowComment ? ('<i class="fa fa-copy" title="Click to copy" ng-click="vm.copy(' + rowIndex + ',\'' + col.id + '\')"></i>' +
				'<i class="fa fa-paste" title="Click to paste" ng-click="vm.paste(' + rowIndex + ', \'' + col.id + '\',\'' + params.controllerName + '\')"></i>') : '';
			var cellClass = '';
			var editHtml = '';
			var actionIconsHtml = '';

			if (!allowComment) {
				cellClass += ' no-edit';
			} else {
				editHtml = editIcon(ngClickEdit);
				actionIconsHtml = '<div class="inlineActionIcons with-copy" id="actionIcons">' +
					copyAndPaste +
					'</div>';
			}

			return '<div class="cell-div invalidHighlight inline-edit-cell"  id="' + col.id + row.ndx + '">' +
				'<div class="edit-name-text' + cellClass + ' with-copy ng-binding" title="' + valEscapedQuotes + '" uib-tooltip-html="vm.getTooltip(\'' + ndxColumn + '\',' + commentNdx + ')" ' +
				' tooltip-is-open="vm.tooltipIsReady(\'' + ndxColumn + '\',' + commentNdx + ')" tooltip-animation="false" tooltip-placement="auto left"' +
				'tooltip-append-to-body="true" ng-mouseenter="' + show + '" ng-mouseleave="' + hide + '"' + ngClickEdit + '>' +
				'<div class="name-field">' + value + '</div>' +
				editHtml +
				'</div>' + actionIconsHtml + '</div>';
		}

		function sboInlineColor(row, col, rowIndex, params) {
			var value = strip(row[col.id]);
			var ndxKey = col.ndxKey;
			var commentType = col.commentType ? '\'' + col.commentType + '\'' : '\'comment\'';
			if (!value || value === 'LEANDNA_NONE') value = '';
			var title = colorClassMap[value] || '';
			var allowCommentString = params.allowInlineEdit;
			var tooltipString = 'vm.getTooltip(\'' + ndxKey + '\',' + row.ndx + ')';
			var show = 'vm.showIt(\'' + ndxKey + '\' , ' + row.ndx + ' , \'' + col.id + '\' ,\'Color\', ' + rowIndex + ', ' + commentType + ')';
			var hide = 'vm.hideIt(\'' + ndxKey + '\', ' + row.ndx + ' , \'' + col.id + '\')';
			var ngClickEdit = allowCommentString ? ' ng-click="vm.startEditList(' + rowIndex + ',\'' + col.id + '\')"' : '';
			var content = '';
			var cellClass = '';
			var hasContent = true;
			var nameFieldClass = '';
			var editHtml = '';

			if (value && value.length) {
				content = '<i class="fa fa-fw fa-circle"></i>';
			} else {
				hasContent = false;
				nameFieldClass += ' emptyContent';
			}

			if (!allowCommentString) {
				cellClass += ' no-edit';
			} else if (hasContent) {
				editHtml = editIcon(ngClickEdit);
			}

			return '<div class="cell-div invalidHighlight inline-edit-cell ' + value + '">' +
				'<div class="edit-name-text' + cellClass + ' ng-binding" title="' + title + '" uib-tooltip-html="' + tooltipString + '" ' +
				'tooltip-append-to-body="true" ' +
				'tooltip-trigger="none" tooltip-is-open="vm.tooltipIsReady(\'' + ndxKey + '\',' + row.ndx + ')" tooltip-animation="false" tooltip-placement="right"' +
				'ng-mouseenter="' + show + '" ng-mouseleave="' + hide + '"' + ngClickEdit + '>' +
				'<div class="name-field' + nameFieldClass + '">' + content + '</div>' +
				editHtml +
				'</div>' +
				'</div>';
		}

		function sboInlineList(row, col, rowIndex, params) {
			var value = strip(row[col.id]);
			var valEscapedQuotes = value.replace(/\"/g, '&quot;');
			var ndxKey = 'cmtRspNdx';
			if (!value || value === 'LEANDNA_NONE') value = '';
			var allowCommentString = params.allowInlineEdit;
			var tooltipString = 'vm.getTooltip(\'' + ndxKey + '\',' + row.ndx + ')';
			var show = 'vm.showIt(\'' + ndxKey + '\' , ' + row.ndx + ' , \'' + col.id + '\' ,\'Responsible\', ' + rowIndex + ', \'comment\')';
			var hide = 'vm.hideIt(\'' + ndxKey + '\', ' + row.ndx + ' , \'' + col.id + '\')';
			var ngClickEdit = allowCommentString ? ' ng-click="vm.startEditList(' + rowIndex + ',\'' + col.id + '\')"' : '';
			var editHtml = '';
			var actionIconsHtml = '';
			var cellClass = 'with-copy';
			if (!allowCommentString) {
				cellClass += ' no-edit';
			} else {
				editHtml = editIcon(ngClickEdit);
				actionIconsHtml += '<div class="inlineActionIcons with-copy" id="actionIcons">' +
					'<i class="fa fa-copy" title="Click to copy" ng-click="vm.copy(' + rowIndex + ', \'' + col.id + '\')"></i>' +
					'<i class="fa fa-paste" title="Click to paste" ng-click="vm.paste(' + rowIndex + ', \'' + col.id + '\')"></i>' +
					'</div>';
			}
			return '<div class="cell-div invalidHighlight inline-edit-cell">' +
				'<div class="edit-name-text ' + cellClass + ' ng-binding" title="' + valEscapedQuotes + '" uib-tooltip-html="' + tooltipString + '" ' +
				'tooltip-append-to-body="true" ' +
				'tooltip-trigger="none" tooltip-is-open="vm.tooltipIsReady(\'' + ndxKey + '\',' + row.ndx + ')" tooltip-animation="false" tooltip-placement="auto left"' +
				'ng-mouseenter="' + show + '" ng-mouseleave="' + hide + '"' + ngClickEdit +	'>' +
				'<div class="name-field">' + value + '</div>' +
				editHtml +
				'</div>' +
				actionIconsHtml +
				'</div>';
		}

		function targetInventoryRenderer(row, col, rowIndex, params) {
			var ldf = row.leanDirFactoryNdx || row.factoryNdx;
			var val = row[col.id];
			if (typeof val === 'undefined') {
				return '<div ng-non-bindable class="cell-div"></div>';
			}
			if (ldf && params.conversionFactorBySite && params.conversionFactorBySite[ldf]) {
				val = val * params.conversionFactorBySite[ldf];
			}
			val = currencyFormatService.getWithParameters(val, 0, params.currencySymbol);
			var url;
			var filters = [
				drilldownFunctionsService.makeSelectFilter('factory', row.leanDirFactoryNdxs),
				drilldownFunctionsService.makeSelectFilter('supplierNdx', row.supplierNdxs)
			];;
			url = siteUrl + 'f/home.html#/supply-chain/inventory-opportunities/pfep-all-items/' + drilldownFunctionsService.makeDrilldownParamString(filters, false);
			
			var aTag = '<a title="Click to see detailed target savings report" href="' + url + '">' + val + '</a>';
			return '<div ng-non-bindable class="cell-div">' + aTag + '</div>';
		}

		function inventoryActionsRenderer(row, col, rowIndex, params) {
			var aTag = '';
			var val = row[col.id];
			if (typeof val !== 'undefined') {
				var ldf = row.leanDirFactoryNdx || row.factoryNdx;
				if (ldf && params.conversionFactorBySite && params.conversionFactorBySite[ldf]) {
					val = val * params.conversionFactorBySite[ldf];
				}
				val = currencyFormatService.getWithParameters(val, 0, params.currencySymbol);
				if (globalConfig.user.role === 'Supplier') {
					aTag = val;
				} else {
					var url = siteUrl + 'f/home.html#/supply-chain/inventory-actions/?drilldown=1&supplierNdx=' + row.supplierNdxs + '&factory=' + row.leanDirFactoryNdxs + '&inventoryActionStatus=isOpen';
					aTag = '<a title="Click to see detailed inventory actions report" href="' + url + '">' + val + '</a>';
				}
			}
			return '<div ng-non-bindable class="cell-div">' + aTag + '</div>';
		}

		function perfRenderer(row, col, rowIndex, params) {
			var value = row[col.id];
			var dec = 0;
			if (col.id === 'costperfmonth3' || col.id === 'costperfrollingavg') dec = undefined;
			if (value || value == 0) {
				if (col.extraFormat == 'percentage') {
					value = percentageFormatService.getWithParameters(value, dec);
				} else {
					value = numberFormatService.getWithParameters(value);
				}
				var colId = col.id;
				if (colId === 'qualityperfmonth3') colId = 'qualityPerf';
				if (colId === 'costperfmonth3') colId = 'costPerf';
				var extraClass = row[colId + 'Rnk'] + (col.includeTrendLine ? ' with-trendline' : '');
				var circle = '<div class="deltaArrowContainer"><i class="fa fa-circle small-circle"></i></div>';
				var valueDiv = '<div class="deltaValue {0}" {1}>' + value + '</div>';
				var trend = col.includeTrendLine ? delPerfTrendline(row, rowIndex) : '';
				var openSOTDModel = '';
				if (col['showSOTD']) {
					openSOTDModel = ' ng-click="vm.openSupplierScoreCard(' + rowIndex + ');$event.stopPropagation();" ';
					valueDiv = String.format(valueDiv, 'slide-in-link', '');
				} else {
					valueDiv = String.format(valueDiv, '', 'style="color:#333"');
				}
				return '<div class="cell-div ' + extraClass + '" title="' + col.title + ': ' + value + '" ' + openSOTDModel + '>' + trend + circle + valueDiv + '</div>';
			} else {
				return '<div class="cell-div"></div>';
			}
		}

		function delPerfTrendline(row, rowIndex) {
			var values = [];
			for (var i = 12; i >= 1; i--) {
				values.push(row['delPerfMonthBucket'+i] || null);
			}
			return '<lean-spark values="'+JSON.stringify(values)+'" suppliers="['+row['supplierNdxs']+']" key="'+rowIndex+'"></lean-spark>';
		}


		function deltaPerformanceRenderer(row, col, rowIndex, params) {
			var value = row[col.id];
			var arrow = '';
			var extraClass = '';
			if (value < 0) {
				value = value * -1;
				extraClass = 'good';
				arrow = '<div class="deltaArrowContainer"><i class="fa fa-arrow-down small-arrow"></i></div>';
			} else if (value > 0) {
				arrow = '<div class="deltaArrowContainer"><i class="fa fa-arrow-up small-arrow"></i></div>';
				extraClass = 'bad';
			}
			if (col.extraFormat == 'currency') {
				var ldf = row.leanDirFactoryNdx || row.factoryNdx;
				if (ldf && params.conversionFactorBySite && params.conversionFactorBySite[ldf]) {
					value = value * params.conversionFactorBySite[ldf];
				}
				value = currencyFormatService.getWithParameters(value, 0, params.currencySymbol);
			}
			var valueDiv = '<div class="deltaValue">' + value + '</div>';
			return '<div ng-non-bindable class="cell-div ' + extraClass + '" title="' + value + '">' + arrow + valueDiv + '</div>';
		}



		function daysUntilPOFirmRenderer(row, col, rowIndex, params) {
			var daysUntilPOFirm = row[col.id];
			if (daysUntilPOFirm === undefined || daysUntilPOFirm === null || daysUntilPOFirm === '') {
				return '<div class="cell-div" title="Cannot calculate lead time window."></div>';
			}
			var procurementLeadTime = parseInt(row['procurementLeadTimeDays']);
			// Check if delivery was too early
			var colorClass = '';
			var explanation = '';
			if (daysUntilPOFirm < 0) {
				colorClass = ' red';
				explanation = 'This order is inside the supplier lead time window';
			} else if (daysUntilPOFirm < procurementLeadTime) {
				colorClass = ' yellow';
				explanation = 'This order is inside the procurement lead time window';
			}
			return '<div class="cell-div' + colorClass + '" title="' + explanation + '">' + daysUntilPOFirm + '</div>';
		}

		function projectStageRenderer(row, col, rowIndex, params) {
			var rawHtml = '<div class="cell-div stage-padding cell-align-center">';
			if (row.stageSequence > -1 && row.stageSequence < 1000 && !row.completeFlag) {
				rawHtml += '<div> ';
				var stages = params.stageListMap[row.leanDirFactoryNdx || row.factoryNdx];
				for (var i = 0; i < stages.length; i++) {
					if (stages[i].stageSequence !== -1 && stages[i].stageSequence !== 1000) {
						rawHtml += '<div ' +
							'title="' + projectRenderService.getStageTitle(row.stageSequence, stages[i].stageSequence, stages[i].name, row.status) + '" ' +
							'class="dmaicLetter ' + projectRenderService.getStageColor(row.stageSequence, stages[i].stageSequence, row.status) + '" ' +
							'>' + stages[i].code + '</div>';
					}
				}
				rawHtml += '</div>';
			} else if (row.stageSequence === -1) {
				rawHtml += '<div class="stage-text-only" translate>Pending Approval</div>';
			} else if (row.stageSequence === 1000) {
				rawHtml += '<div class="stage-text-only" translate>Archive</div>';
			} else if (row.completeFlag && row.stageSequence !== 1000) {
				rawHtml += '<div class="stage-complete stage-text-only" style="width:' + params.completeWidth + ';margin-left: calc((100% - ' + params.completeWidth + ') / 2);" translate>Complete</div>';
			}
			rawHtml += '</div>';
			return rawHtml;
		}

		function projectNameRenderer(row, col, rowIndex, params) {
			var projNdxString = row.projNdx + ', ' + (row.leanDirFactoryNdx || row.factoryNdx);
			var extraClass = '';
			var actionElement = '';
			if (projectRenderService.hasDelete(row.stageName, row.projectManagerNdx, row.adminNdx, row.projectSponsorNdxs, row.userIsApprover, row.leanDirFactoryNdx || row.factoryNdx)) {
				extraClass = 'with-action';
				actionElement = projectRenderService.getActionElement('Delete', row);
			} else if (projectRenderService.hasApprove(row.stageName, row.projectManagerNdx, row.adminNdx, row.userIsApprover, row.leanDirFactoryNdx || row.factoryNdx)) {
				extraClass = 'with-action';
				actionElement = projectRenderService.getActionElement('Approve', row);
			} else if (projectRenderService.hasArchive(row.stageName, row.projectManagerNdx, row.adminNdx, row.projectSponsorNdxs, row.creatorNdx, row.userIsApprover, row.leanDirFactoryNdx || row.factoryNdx)) {
				extraClass = 'with-action';
				actionElement = projectRenderService.getActionElement('Archive', row);
			}

			return '<div class="cell-div inline-edit-cell">' +
				'<div class="edit-name-text ' + extraClass + '">' +
				'<div class="table-a3-icon ' + projectRenderService.getColor(row.status, row.completeFlag, row.stageSequence) + '" ' +
				'ng-click="vm.viewA3Report(' + projNdxString + ')">A3</div>' +
				'<a href="' + projectRenderService.getHyperLink(row.projNdx, row.leanDirFactoryNdx || row.factoryNdx, params.viewLink) + '">' + strip(row.name) + '</a>' +
				'</div>' +
				'<div class="inlineActionIcons">' + actionElement + '</div>' +
				'</div>';
		}

		function projectDueDateRenderer(row, col, rowIndex, params) {
			var extraClass = projectRenderService.overdueDate(row.dueDate, row.completeFlag, row.stageSequence, row.leanDirFactoryNdx || row.factoryNdx, params.stageListMap) ? 'red' : '';
			var displayDate = convertDate(row, col, 'mediumDate', col.id);
			return '<div class="cell-div ' + extraClass + '">' +
				displayDate + '</div>';
		}

		function projectManagerRenderer(row, col, rowIndex, params) {
			return '<div class="cell-div cell-align-left">' +
				row[col.id] +
				(row.projectManagerStatus === 'inactive' ? '<span> (inactive)</span>' : '') +
				'</div>';
		}

		function avgPeriodicDemand(row, col, rowIndex, params) {
			var factoryNdx = row.leanDirFactoryNdx || row.factoryNdx;
			var isPastRequirements = ['averageMonthlyDemandFromPastRqmts', 'averageDailyDemandFromPastRqmts'].includes(col.id);
			var report = isPastRequirements ? 'supply-chain/past-requirements/' : 'supply-chain/requirements/weekly-requirements/';
			var flag = null;
			var isReactTable = true;

			var url = drilldownFunctionsService.getReportDrilldownUrl(report, flag, {
				search: row.fullItemCode,
				factory: factoryNdx
			}, isReactTable);

			var multiplier;
			var divider = 1;
			if (col.inputPeriod === 'monthly') {
				divider = 22;
			}
			if (col.period === 'daily') {
				multiplier = 1;
			} else { // default to monthly
				multiplier = 22;
			}
			var val = row[col.id] * multiplier / divider;
			var nAfterDecimal = 2;
			if (val > 0 && val < 0.01) {
				nAfterDecimal = 4;
			}
			val = $filter('number')(val, nAfterDecimal);

			var returnValue = val;
			if (col.usingOrders) {
				returnValue = val;
			} else {
				if (globalConfig.user.role !== 'Supplier') {
					returnValue = '<a title = "Click to view requirements for this item." href="' + url + '">' + val + '</a>';
				}
			}
			return '<div class="cell-div" title="' + val + '">' + returnValue + '</div>';
		}

		function targetQtyRenderer(row, col, rowIndex, params) {
			var origVal = row[col.id];
			var roundedVal = Math.round(origVal);
			if (origVal < 1 && origVal > 0)
				roundedVal = 1;
			var val = $filter('number')(roundedVal, 0);
			return '<div class="cell-div" title="' + val + '">' + val + '</div>';
		}

		function ppvRenderer(row, col, rowIndex, params) {
			var decimals = row['decimals'];
			var val = row[col.id];
			var keepAllDecimals = col['keepAllDecimals'];
			decimals = numberOfDecimals(val, decimals, keepAllDecimals);
			if (decimals == 1) decimals = 2;
			var colorClass = '';
			if (val > 0)
				colorClass = 'red';
			else if (val < 0)
				colorClass = 'green';
			if (val) {
				var ldf = row.leanDirFactoryNdx || row.factoryNdx;
				if (ldf && params.conversionFactorBySite && params.conversionFactorBySite[ldf]) {
					val = val * params.conversionFactorBySite[ldf];
				}
				if (!params.currencySymbol) {
					val = currencyFormatService.getWithParametersNegativeSign(val, decimals);
				} else {
					val = currencyFormatService.getWithParametersNegativeSign(val, decimals, params.currencySymbol);
				}
				return '<div class="cell-div shift-right viewSpendAnalyticsByItemReport ' + colorClass + '" title="' + val + '">' + val + '</div>';
			}
			return '<div class="cell-div"></div>';
		}

		function onOrderNextXDays(row, col, rowIndex, params) {
			var numDays = col.days;
			var dateRange = {};
			if (numDays) {
				dateRange = getNextDays(numDays);
			}
			var today = new Date();
			var reactDrilldownFilters = [
				drilldownFunctionsService.getMinimalFilterFromReportSettings({id: 'documentType', unselectedValues: ['Purchase Requisition']}),
				drilldownFunctionsService.makeRangeFilter('goldenSupplyDate', leanFilterService.comparatorsMap.lessThanOrEqual, dateRange.end),
				drilldownFunctionsService.makeRangeFilter('remainingQuantityFloat', leanFilterService.comparatorsMap.greaterThan, 0)
			];
			if (params != undefined && params.excludePurchaseReqs) {
				reactDrilldownFilters.push({ id: 'excludePurchaseReqs', values: ['1']});
			}
			var url = drilldownFunctionsService.getReportDrilldownUrl('supply-chain/supply-orders', null, {
				reactParams: {
					filters: reactDrilldownFilters,
					sorters: [{ property: 'goldenSupplyDate', direction: 'ASC' }],
					search: row.fullItemCode
				},
				search: row.fullItemCode,
				nextDaysEnd: dateRange.end,
				sort: 'goldenSupplyDate',
				onOrderValueOne: 0,
				onOrderComparator: 'gt',
				excludePurchaseReqs: params != undefined && params.excludePurchaseReqs ? '1' : null,
				factory: params && params.multiFactory ? (row.leanDirFactoryNdx || row.factoryNdx) : null
			}, true);
			url += '&isOnOrderDrilldown=true';
			var rawValue = row[col.id];
			var val = undefined;
			if (rawValue || rawValue == 0) {
				var ldf = row.leanDirFactoryNdx || row.factoryNdx;
				if (ldf && params.conversionFactorBySite && params.conversionFactorBySite[ldf]) {
					rawValue = rawValue * params.conversionFactorBySite[ldf];
				}
				val = currencyFormatService.getWithParametersNegativeSign(rawValue, 0, params.currencySymbol);
			}
			var url = globalConfig.user.role !== 'Supplier' ? '<a title="Click to view purchase orders for this item." href="' + url + '">' + val + '</a>' : val;
			return '<div class="cell-div" title="' + val + '">' + url + '</div>';
		}

		function onOrderValue(row, col, rowIndex, params) {
			var reactDrilldownFilters = [
				drilldownFunctionsService.getMinimalFilterFromReportSettings({id: 'documentType', unselectedValues: ['Purchase Requisition']}),
				drilldownFunctionsService.makeRangeFilter('remainingQuantityFloat', leanFilterService.comparatorsMap.greaterThan, 0)
			];
			if (params != undefined && params.excludePurchaseReqs) {
				reactDrilldownFilters.push({ id: 'excludePurchaseReqs', values: ['1']});
			}
			var url = drilldownFunctionsService.getReportDrilldownUrl('supply-chain/supply-orders', null, {
				reactParams: {
					filters: reactDrilldownFilters,
					sorters: [{ property: 'goldenSupplyDate', direction: 'ASC' }],
					search: row.fullItemCode
				},
				search: row.fullItemCode,
				sort: 'goldenSupplyDate',
				onOrderValueOne: 0,
				onOrderComparator: 'gt',
				excludePurchaseReqs: params != undefined && params.excludePurchaseReqs ? '1' : null,
				factory: params && params.multiFactory ? (row.leanDirFactoryNdx || row.factoryNdx) : null
			}, true);
			url += '&isOnOrderDrilldown=true';
			var rawValue = row[col.id];
			var val = undefined;
			if (rawValue || rawValue == 0) {
				var ldf = row.leanDirFactoryNdx || row.factoryNdx;
				if (ldf && params.conversionFactorBySite && params.conversionFactorBySite[ldf]) {
					rawValue = rawValue * params.conversionFactorBySite[ldf];
				}
				val = currencyFormatService.getWithParametersNegativeSign(rawValue, 0, params.currencySymbol);
			}
			var url = globalConfig.user.role !== 'Supplier' ? '<a title="Click to view purchase orders for this item." href="' + url + '">' + val + '</a>' : val;
			return '<div class="cell-div shift-right" title="' + val + '">' + url + '</div>';
		}

		function getNextDays(numDays) {
			var result = {};
			var start = new Date();
			var end = new Date();
			end.setDate(start.getDate() + numDays);
			var monthStart = (start.getMonth() + 1) < 10 ? '0' + (start.getMonth() + 1) : start.getMonth() + 1;
			var monthEnd = (end.getMonth() + 1) < 10 ? '0' + (end.getMonth() + 1) : end.getMonth() + 1;
			var dayStart = start.getDate() < 10 ? '0' + start.getDate() : start.getDate();
			var dayEnd = end.getDate() < 10 ? '0' + end.getDate() : end.getDate();
			result.start = start.getFullYear() + '-' + monthStart + '-' + dayStart;
			result.end = end.getFullYear() + '-' + monthEnd + '-' + dayEnd;
			result.start = moment.utc(result.start).unix() * 1000;
			result.end = moment.utc(result.end).unix() * 1000;
			return result;
		}

		function shortageOnOrderQuantity(row, col, rowIndex, params) {
			var formattedVal = convertInteger(row[col.id], true);
			if (!row['purchaseOrderNumber'] || formattedVal == 0 || typeof formattedVal === 'undefined') {
				formattedVal = '';
			}
			return '<div class="cell-div shift-right" title="" >' + formattedVal + '</div>';
		}

		function potentialToSell(row, col, rowIndex, params) {
			var rawValue = row[col.id];
			var val = '';
			if (rawValue && rawValue !== 0) {
				val = convertToCurrency(row,col,params,rawValue);
			}
			var openDetail = 'vm.openExcessToSellDetail(' + rowIndex + ','+ params.siteIDs[col.id] + ',\'' + params.siteNames[col.id] + '\')';
			var ret = '<div class="cell-div shift-right">' + '<a ng-href class="anchor-link" ng-click="'+openDetail+'">' + val +'</a></div>';
			return ret;

		}

		function uiBootstrapTooltip(row, col, rowIndex, params) {
			var cellVal = row[col.id] || '';
			var tooltipVal = cellVal;
			if (cellVal && cellVal.length) {
				tooltipVal = cellVal.substring(0, 2048);
				if (cellVal.length > tooltipVal.length) {
					tooltipVal += '...';
				}
			}
			return '<div class="cell-div poNotesCell alignLeft" uib-tooltip="' +
				tooltipVal + '" tooltip-placement="right">' + cellVal +
				'</div>';
		}

		function ytdProjectSavingsRenderer(row, col, rowIndex, params) {
			var content = row[col.id];
			if (row.hasOwnProperty(col.id) && content === 0) {
				return '<div class="cell-div"></div>';
			}
			content = convertToCurrency(row, col, params, content);
			var classString = 'class="cell-div ';

			if (content || content == 0) {
				classString += 'shift-right " ';
				var ndxKey = 'projNdx';
				if (!content) content = '';
				var label = 'Monthly Project Savings';
				var type = 'YtdProject';
				var tooltipString = 'vm.getTooltip(\'' + col.id + '\',' + row.projNdx + ')';
				var show = 'vm.showIt(\'' + col.id + '\' , ' + row.projNdx + ' , \'' + type + '\' ,\'' + label + '\', ' + rowIndex + ', \'comment\')';
				var hide = 'vm.hideIt(\'' + col.id + '\', ' + row.projNdx + ' , \'' + type + '\')';

				return '<div ' + classString + ' id="' + col.id + row.ndx + '">' +
					'<div ng-binding" title="' + content + '" uib-tooltip-html="' + tooltipString + '" ' +
					'tooltip-append-to-body="true" ' +
					'tooltip-trigger="none" tooltip-is-open="vm.tooltipIsReady(\'' + col.id + '\',' + row.projNdx + ')" tooltip-animation="false" tooltip-placement="auto left"' +
					'ng-mouseenter="' + show + '" ng-mouseleave="' + hide + '">' + content + '</div>' +
					'</div>';
			} else {
				classString += ' " ';
			}
			return '<div ' + classString + '></div>';
		}

		function ytdProjectSavingsDeltaRenderer(row, col, rowIndex, params) {
			var content = row[col.id];
			if (row.hasOwnProperty(col.id) && content === 0) {
				return '<div class="cell-div"></div>';
			}
			var classString = 'class="cell-div shift-right ';
			var deltaDirection = 'up';
			if (content > 0) {
				classString += 'good "';
			} else if (content < 0) {
				classString += 'bad"';
				deltaDirection = 'down';
			}
			content = convertToCurrency(row, col, params, content);
			if (content || content == 0) {
				var rawHtml = '<div ' + classString + ' title="' + content + '">';
				rawHtml += '<div class="deltaArrowContainer"><i class="fa fa-arrow-' + deltaDirection + ' small-arrow"></i></div>';
				rawHtml += '<div class="deltaValue">' + content + '</div></div>';
				return rawHtml;
			} else {
				classString += ' " ';
			}
			return '<div ' + classString + '></div>';
		}

		function taskPriority(row, col, rowIndex, params) {
			var val = row['priority'];
			var classString = 'cell-div ';
			if (params.lastIndex && rowIndex == params.lastIndex) {
				classString += 'footer ';
			}
			var rawHtml = '<div class="' + classString + '"';
			if (val) {
				rawHtml += '" title="' + val + '">' + val;
			} else {
				rawHtml += '>';
			}
			rawHtml += '</div>';
			return rawHtml;
		}

		function onHand(row, col, rowIndex, params) {
			var decimals = row['decimals'];
			var val = row[col.id];
			if (!decimals) {
				decimals = 0;
			}
			decimals = numberOfDecimals(val, decimals, false);
			var formattedVal = val;
			if (decimals || decimals == 0) {
				formattedVal = $filter('number')(val, decimals);
			}
			if (!(formattedVal || formattedVal == 0)) {
				formattedVal = '';
			}
			if (col.itemType !== 'manufactured') {
				col.itemType = 'purchased';
			}
			// col.onHandType is one of 'integer-uom' | 'integer' | 'value'
			if (col.onHandType === undefined) {
				col.onHandType = 'integer-uom';
			}
			if (col.shouldGotoUnrestrictedFilter === undefined) {
				col.shouldGotoUnrestrictedFilter = true;
			}

			var url = drilldownFunctionsService.getReportDrilldownUrl(
				'supply-chain/inventory/' + col.itemType + '-inventory',
				'react-' + col.itemType + '-inventory',
				{
					state: col.shouldGotoUnrestrictedFilter ? 'Unrestricted' : undefined,
					search: row.fullItemCode
				}
			);

			var displayedVal = formattedVal;
			if (col.onHandType === 'value') {
				displayedVal = currencyFormatService.getWithParameters(val, decimals, params.currencySymbol);
			} else if (col.onHandType === 'integer-uom') {
				var uom = row[params.uomId];
				if (uom === undefined)
					uom = '';
				displayedVal += ' ' + uom;
			}
			var returnValue = '<a title="Click to view inventory information for this item code." href="' + url + '" >' + displayedVal + '</a>';
			var factories = (row.leanDirFactoryNdx || row.factoryNdx).toString();
			var sameFactory = true;
			if (factories && factories.length) {
				var factoryList = factories.toString().split(',');
				sameFactory = factoryList.indexOf(globalConfig.factory.id.toString()) >= 0;
			}
			if (formattedVal === 0) {
				displayedVal = '';
			}
			if (params.isSupplierPortal || !authorize(['supplyChain', 'reports']) ||
				(params.multiFactory && !sameFactory)) {
				returnValue = displayedVal;
			}
			if (globalConfig.user.role === 'Supplier') {
				returnValue = displayedVal;
			}
			return '<div class="cell-div cell-align-right">' + returnValue + '</div>';
		}


		function earlyDeliveries(row, col, rowIndex, params) {
			var numDays = col.days;
			var dateRange = {};
			if (numDays) {
				dateRange = getNextDays(numDays);
			}
			var today = new Date();
			var decimals = row['decimals'];
			if (!decimals) decimals = 0;
			var val = row[col.id];
			if (val < 1 && val > -1)
				decimals = numberOfDecimals(val, decimals, false);
			if (val == 0) decimals = 0;
			var formattedVal = val;
			if (decimals || decimals == 0) {
				formattedVal = currencyFormatService.getWithParameters(val, decimals, params.currencySymbol);
			}
			var url;
			var filters = [{ id: 'deliveryStatus', values: ['Delivered - Early'] },
				{ id: 'actualReceiptDate', comparator: 'Between', valueOne: dateRange.start, valueTwo: dateRange.end }];
			if(excludeBlanketOrdersFilter){
				filters.push({ id: 'isBlanketOrder', values: [false]});
			}
			var sorters = [{ property: 'scorecardDate', direction: 'DESC' }];
			url = 'home.html#/supply-chain/purchase-orders/' + drilldownFunctionsService.makeDrilldownParamString(filters, false, sorters, row.fullItemCode);
		
			var returnValue = '<a href="' + url + '" target="_blank">' + formattedVal + '</a>';
			return '<div class="cell-div cell-align-right">' + returnValue + '</div>';
		}

		function buyerLogin(row, col, rowIndex, params) {
			var value = row[col.id];
			var buyersWithAccount = row['buyersWithAccount'];
			var classString = 'class="cell-div ';
			if (params.lastIndex && rowIndex == params.lastIndex) {
				classString += 'footer" ';
			} else {
				classString += ' " ';
			}

			if (buyersWithAccount && (value || value == 0)) {
				var rawContent = '\'Buyers Logged In: ' + row['buyersLoggedInLast7Days'] + '<br/> ' +
					'Total Buyers: ' + buyersWithAccount + '\'';
				var tooltip = ' uib-tooltip-html="' + rawContent + '" ' +
					'tooltip-append-to-body="true" tooltip-animation="false" tooltip-placement="auto left"';
				value = value * 100;
				value = percentageFormatService.getWithParameters(value, 0);
				var drilldownParams = {
					dashboardType: 'Buyer Performance',
					factory: leanFilterService.getSelectedIds('factory')
				};
				var link = '<a href="' + addQueryParam(URLS.frontendPrefix + 'dashboard/byType?drilldown=1', null, drilldownParams, false) + '" target="_blank">' + value + '</a>';
				return '<div ' + classString + ' ' + tooltip + '>' + link + '</div>';
			} else {
				return '<div class="cell-div"></div>';
			}
		}

		function nonzeroCurrencyRenderer(row, col, rowIndex, params) {
			var decimals = row['decimals'];
			var val = row[col.id];
			var keepAllDecimals = col['keepAllDecimals'];
			decimals = numberOfDecimals(val, decimals, keepAllDecimals);
			if (decimals == 1) decimals = 2;
			if (val) {
				var val = currencyFormatService.getWithParametersNegativeSign(val, decimals, params.currencySymbol);
				return '<div class="cell-div" title="' + val + '">' + val + '</div>';
			}
			return '<div class="cell-div"></div>';
		}

		function spendSummaryIdentifierRenderer(row, col, rowIndex, params) {
			var val = row[col.id];
			if (!val || val == '') {
				val = col.id === 'supplierName' ? 'Supplier Not Defined' :
					(col.id === 'materialGroup' ? 'MATERIAL GROUP NOT DEFINED' : 'ITEM GROUP NOT DEFINED');
			}
			var title = val;
			if (col.id == 'supplierName') {
				title = row['supplierCode'] + ' : ' + val;
			}
			return '<div class="cell-div" title="' + title + '">' + val + '</div>';
		}

		function getFactoryNdxFromHeader(key, grouping, headerTotals) {
			var headerObject = null;
			if (typeof spendSummaryHeaderMap[key] !== 'undefined') {
				headerObject = spendSummaryHeaderMap[key];
			} else {
				for (var i = 0; i < headerTotals.length; i++) {
					var row = headerTotals[i];
					spendSummaryHeaderMap[headerTotals[i].id] = headerTotals[i];
					if (row.id == key) {
						headerObject = headerTotals[i];
						break;
					}
				}
			}
			return grouping == 'factory' ? (headerObject.leanDirFactoryNdx || headerObject.factoryNdx) : headerObject.name;
		}

		function getSpendSummaryParamByViewBy(viewBy, factNdx, params) {
			return '&' +viewBy + '=' +
				encodeURIComponent(getFactoryNdxFromHeader(factNdx, viewBy,
					params.headerTotals));
		}

		function getSpendSummaryExtraQueryParams(columnId, factNdx, params) {
			var viewBy = leanFilterService.getSelectedIds('viewByBuDivisionEntitySite');
			if (viewBy.length == 0) {
				viewBy = ['site'];
			}
			var extraQueryParam = '';
			var queryParmamObjects = leanFilterService.getQueryParamsObject();
			if (columnId === 'totalForAll') {
				factNdx = leanFilterService.getFactoryList();
				extraQueryParam = '&factory=' + leanFilterService.getFactoryList();
			} else {
				if (typeof viewBy != 'undefined' && viewBy != null && viewBy.length > 0) {
					viewBy = viewBy[0];
					viewBy = (viewBy === 'site' ? 'factory' : viewBy.toLowerCase());
					extraQueryParam = getSpendSummaryParamByViewBy(viewBy, factNdx, params);
				}
			}

			if (viewBy !== 'factory' && columnId !== 'totalForAll') {
				delete queryParmamObjects[viewBy];
			}
			angular.forEach(queryParmamObjects, function(value, key) {
				if (_.includes(['businessunit', 'division', 'entity', 'spendType'], key)) {
					extraQueryParam += '&' + key + '=' + value;
				}
			});

			return extraQueryParam;
		}

		function getSpendSummaryDrilldownUrl(params, row, factNdx, columnId) {
			var extraQueryParam = getSpendSummaryExtraQueryParams(columnId, factNdx, params);
			var url = params.siteUrl + 'f/home.html#/supply-chain/spend-analytics/item-spend/' + '?drilldown=1';
			url += extraQueryParam;
			if (columnId === 'totalForAll') {
				factNdx = leanFilterService.getFactoryList();
			}
			if (params.state.current.name === 'app.supply-chain.spend-summary/supplier-spend') {
				url += '&supplierCode=' + encodeURIComponent(row['supplierCode']);
			} else {
				if (leanFilterService.getSelectedIds('supplierNdx')) {
					url += leanFilterService.getNewQueryParam('supplierNdx', true);
				}
				if (params.state.current.name === 'app.supply-chain.spend-summary/material-group-spend') {
					url += '&materialGroup=' + encodeURIComponent(row['materialGroup']);
				} else if (params.state.current.name === 'app.supply-chain.spend-summary/item-group-spend') {
					url += '&itemGroupName=' + encodeURIComponent(row['itemGroupName']);
				}
			}
			return url;
		}

		function factorySpendRenderer(row, col, rowIndex, params) {
			var decimals = row['decimals'];
			var colId = col.defaultId || col.id;
			var val = row[colId];
			var factNdx = (colId.substring(3));
			var keepAllDecimals = col['keepAllDecimals'];
			decimals = numberOfDecimals(val, decimals, keepAllDecimals);
			if (decimals == 1) decimals = 2;
			var drillDownUrl = getSpendSummaryDrilldownUrl(params, row, factNdx, colId);

			if (val || val == 0) {
				var val = params.currencyFormatter.getWithParametersNegativeSign(val, decimals, params.currencySymbol);
				var returnValue = '<a title="Click to view item spend information for this factory." href="' + drillDownUrl + '" >' + val + '</a>';
				return '<div class="cell-div shift-right">' + returnValue + '</div>';
			}
			return '<div class="cell-div"></div>';
		}

		function inlineAssessmentEdit(row, col, rowIndex, params) {
			var columnId = col.id;
			var content = row[columnId] ? row[columnId] : '';
			var html;
			content = columnId !== 'rating' ? content.replace(/\"/g, '&quot;') : content;
			var dropDownValue = '';
			var extraCss = '';
			var editHtml = '';
			var nameFieldClass = '';
			if (columnId === 'rating') {
				dropDownValue = row['rating'] ? row['rating'] : '';
			}

			var ngClickEdit = '';
			if (columnId === 'comments') {
				ngClickEdit = ' ng-click="vm.startEdit(' + rowIndex + ',\'' + col.id + '\', \'Comments And Action\', \'textArea\', 10000)" ';
			} else {
				ngClickEdit = ' ng-click="vm.startEditList(' + rowIndex + ',\'' + col.id + '\', \'' + dropDownValue + '\')" ';
			}

			if (!content) {
				nameFieldClass += ' emptyContent';
			} else {
				editHtml += editIcon(ngClickEdit);
			}

			html = '<div class="cell-div invalidHighlight inline-edit-cell' + extraCss + '" ';
			if (columnId === 'comments') {
				html += ' uib-tooltip="' + content + '" ' +
					'tooltip-append-to-body="true" tooltip-animation="false" tooltip-placement="auto" ';
			} else {
				html += ' title="' + content + '" ';
			}
			html += ' id="firstPoStatus' + row.ndx + '">' +
				'<div class="edit-name-text ng-binding" id="inlineStatus" ' + ngClickEdit + '>';
			html += '<div class="name-field' + nameFieldClass + '">' + content + '</div>';
			html += editHtml;
			html += '</div>';
			html += '</div>';

			return html;
		}

		function assessmentQuestion(row, col, rowIndex, params) {
			var columnId = col.id;
			var content = row[columnId] ? strip(row[columnId]) : '';
			var assessmentNdx = row['assessmentNdx'];
			var html;
			var type = 'assessmentQuestion';
			content = content.replace(/\"/g, '&quot;');
			var tooltipString = 'vm.getTooltip(\'' + col.id + '\',' + assessmentNdx + ')';
			var show = 'vm.showIt(\'' + col.id + '\' , ' + assessmentNdx + ' , \'' + type + '\' ,\'' + '' + '\', ' + rowIndex + ', \'comment\')';
			var hide = 'vm.hideIt(\'' + col.id + '\', ' + assessmentNdx + ' , \'' + type + '\')';
			html = '<div class="cell-div " ';
			html += ' uib-tooltip-html="' + tooltipString + '" ' +
				'tooltip-append-to-body="true" ' +
				'tooltip-trigger="none" tooltip-is-open="vm.tooltipIsReady(\'' + col.id + '\',' + assessmentNdx + ')" tooltip-animation="false" tooltip-placement="left"' +
				'ng-mouseenter="' + show + '" ng-mouseleave="' + hide + '">';
			html += content + '</div>';
			return html;
		}

		function buyerCode(row, col, rowIndex, params) {
			var value = row[col.id] || '';
			value = strip(value.replace(/^UndefinedBuyer$/, ''));
			return '<div class="cell-div">' + value + '</div>';
		}

		function shortageCriticalityLevel(row, col, rowIndex, params) {
			var factoryNdx = row.leanDirFactoryNdx || row.factoryNdx;
			var levelId = row['shortageCriticalityLevelId'] || -1;
			var criticalityLevels = shortageCriticalityLevelService.getShortageCriticalityLevels()[factoryNdx];
			var criticalityLevel = criticalityLevels && criticalityLevels[levelId] ? criticalityLevels[levelId] : {};
			var value = criticalityLevel.label || '';
			var title = criticalityLevel.description || '';
			if (criticalityLevel.label === 'None') {
				value = $translate.instant('Non Critical');
			}
			return '<div class="cell-div" title="' + title + '">' + value + '</div>';
		}

		function lotSizeRenderer(row, col, rowIndex, params) {
			var tempRow = { lotSize: '' };
			var tempCol = { id: 'lotSize' };
			if (row.orderPolicy === 'Fixed Lot Size') {
				tempRow.lotSize = row.fixedOrderQuantityFloat;
			} else {
				tempRow.lotSize = row.orderMultipleFloat;
			}
			return integer(tempRow, tempCol, rowIndex, params);
		}

		function orderIntervalByOrderPolicyRenderer(row, col, rowIndex, params) {
			var orderIntervalNum = row[col.id] || null;
			var orderInterval = orderIntervalNum != null? orderIntervalNum : null;
			var daysDisplayType = row['daysDisplayType'];
			var orderPolicy = row['orderPolicy'];

			if (orderPolicy !== null && orderPolicy === 'Order Interval' && col.id !== 'analysisOrderIntervalInt') {
				var currentValue = row['orderPolicyValue'];
				orderInterval = currentValue;
			}

			if (orderInterval != null) {
				if (daysDisplayType === 'Work Days' && col.id !== 'analysisOrderIntervalInt') {
					orderInterval = Math.round(orderInterval / 7.0 * 5.0);
				}
				if (daysDisplayType !== 'Work Days' && col.id === 'analysisOrderIntervalInt') {
					orderInterval = convertBusinessToCalendarDays(orderInterval);
				}
			}

			return '<div class="cell-div">' + (orderInterval == null ? '' : convertInteger(orderInterval) + ' ' + daysDisplayType) + '</div>';
		}

		function lateDeliveryIssue(row, col, rowIndex, params) {
			var content = $translate.instant(strip(row[col.id] ? row[col.id] : ''));
			var cssClass = 'cell-div invalidHighlight';
			if (col.id === 'lateDeliveryLiability' && content === 'Customer') {
				content = globalConfig.customer.name;
			}
			return '<div class="' + cssClass + '" title="' + content + '">' + content + '</div>';
		}

		function forecastDelivery(row, col, rowIndex, params) {
			var value = row[col.id];
			var isEditable = col.editable;
			var ngClickEdit = '';
			var cellClass = '';
			var editHtml = '';
			var nameFieldClass = '';
			var formattedVal = value;
			var documentType = row['purchaseDocumentType'] || row['firstPoLeanDocumentType'];
			var orderNdx = row.orderNdx || row.forecastFirstDeliveryPoNdx || row.firstPoNdx;

			if (!row['forecastDeliveryCount'] && disableForecastValue(documentType, row['deliveryComplete'], isEditable, orderNdx)) {
				return '<div class="cell-div invalidHighlight grayCell"></div>';
			}
			if (isEditable) {
				ngClickEdit = ' ng-click="vm.startEditForecast(' + rowIndex + ', \'' + col.id + '\');$event.stopPropagation();"';
				editHtml = editIcon(ngClickEdit);
			} else {
				cellClass = ' no-edit';
			}
			if (value == null) {
				formattedVal = '';
				nameFieldClass = ' emptyContent';
				editHtml = '';
			} else if (col.id === 'forecastFirstDeliveryDate') {
				formattedVal = convertDate(row, col, 'mediumDate', col.id);
			} else if (col.id !== 'forecastFirstTrackingNumber' && col.id !== 'forecastFirstComment') {
				formattedVal = convertInteger(row[col.id]);
			}

			return '<div class="cell-div inline-edit-cell">' +
				'<div class="edit-name-text' + cellClass + '" title="' + formattedVal + '"' + ngClickEdit + ' >' +
				'<div class="name-field' + nameFieldClass + '">' + formattedVal + '</div>' +
				editHtml +
				'</div>' +
				'</div>';
		}

		function disableForecastValue(purchaseDocumentType, deliveryComplete, isEditable, orderNdx) {
			if (!isEditable) {
				return false;
			}
			if(!orderNdx){
				return true;
			}
			// Suppliers only see POs, and purchaseDocumentType is a restricted column
			if (globalConfig.user.role === 'Supplier') {
				return deliveryComplete;
			}
			if (!purchaseDocumentType
				|| purchaseDocumentType === 'Purchase Requisition'
				|| purchaseDocumentType === 'Production Order'
				|| purchaseDocumentType === 'Planned Production Order') {
				return true;
			}
			return deliveryComplete;
		}

		function hasMixOfDeliveryPeformanceTypes(factoryNdxs) {
			if (!factoryNdxs || !factoryNdxs.length) {
				return false;
			}
			if (factoryNdxs[0] === 'LDNA_A_S') {
				factoryNdxs = Object.keys(deliveryPerformanceTypeService.getTypes());
			}
			var result = false;
			var firstType = deliveryPerformanceTypeService.getTypes()[factoryNdxs[0]];
			_.forEach(factoryNdxs, function(ndx) {
				var tempType =  deliveryPerformanceTypeService.getTypes()[ndx];
				if (tempType !== firstType) {
					result = true;
				}
			});
			return result;
		}

		function clearSpendSummaryHeaderMap() {
			spendSummaryHeaderMap = {};
		}

		function emailAddressToUserPage(row, col, rowIndex, params) {
			var userNdx = row.userNdx;
			var text = row[col.id];
			var content;
			if (userNdx) {
				content = '<a href="/application/f/home.html#/setup/user-form?userNdx=' + userNdx + '">' + text + '</a>';
			} else {
				content = text;
			}
			return '<div class="cell-div">' + content + '</div>';
		}

		function auditLogContent(row, col, rowIndex, params) {
			var rawValue = row[col.id];
			var shortenedValue = rawValue.substring(0, 15);
			if (rawValue.length > 15) {
				shortenedValue += '...';
			}
			var openDetail = 'vm.openAuditLogContent(' + rowIndex + ')';
			var ret = '<div class="cell-div">';
			ret += '<a ng-href class="anchor-link" ng-click="' + openDetail + '">' + shortenedValue + '</a></div>';
			return ret;
		}

		function emailContent(row, col, rowIndex, params) {
			var rawValue = row[col.id];
			var openDetail = 'vm.openEmailPreview(' + rowIndex + ')';
			var ret = '<div class="cell-div">';
			if (row.sesMessageId) {
				ret += '<a href="#"><i class="fa fa-download" ng-click="$event.preventDefault();vm.downloadEmailTrigger(' + rowIndex + ')"></i></a> ';
			}
			ret += '<a ng-href class="anchor-link" ng-click="' + openDetail + '">' + rawValue +'</a></div>';
			return ret;
		}

		function futurePPVRenderer(row, col, rowIndex, params) {
			var decimals = row['decimals'];
			var val = row[col.id];
			var keepAllDecimals = col['keepAllDecimals'];
			decimals = numberOfDecimals(val, decimals, keepAllDecimals);
			if (decimals == 1) decimals = 2;
			var colorClass = '';
			if (val > 0)
				colorClass = 'red';
			else if (val < 0)
				colorClass = 'green';
			if (val) {
				var ldf = row.leanDirFactoryNdx || row.factoryNdx;
				if (ldf && params.conversionFactorBySite && params.conversionFactorBySite[ldf]) {
					val = val * params.conversionFactorBySite[ldf];
				}
				if (!params.currencySymbol) {
					val = currencyFormatService.getWithParametersNegativeSign(val, decimals);
				} else {
					val = currencyFormatService.getWithParametersNegativeSign(val, decimals, params.currencySymbol);
				}
				return '<div class="cell-div ' + colorClass + '" title="' + val + '">' + val + '</div>';
			}
			return '<div class="cell-div"></div>';
		}

		function startCase(row, col, rowIndex, params) {
			var val = _.startCase(row[col.id]);
			return '<div class="cell-div" title="' + val + '">' + val + '</div>';
		}

		function poPlacementTime(row, col, rowIndex, params) {
			var val = row[col.id];

			if (val || val == 0) {
				if (val === 0) {
					val = 'On Time';
				} else {
					val = numberFormatService.getWithParameters(val, 0) + ' Days Late';
				}
				return '<div class="cell-div" title="' + val + '">' + val + '</div>';
			}
			return '<div class="cell-div"></div>';
		}

		function poConfirmationStatus(row, col, rowIndex, params) {
			var val = row[col.id];

			if (val === '-') {
				val = 'unconfirmed';
			}
			val = _.startCase(val);
			return '<div class="cell-div" title="' + val + '">' + val + '</div>';
		}

		function viewMetricDataAction(row, col, rowIndex) {
			var startingHTML = '<div class="cell-div legacy-action cell-align-center">' +
				'<div class="inlineActionIcons actionColumn static">';
			var closingHTML = '</div></div>';
			var hasPrivileges= (
				row.metricType === 'Manual' && !row.isCategorized && row.resultType !== 'suspend' && (
					globalConfig.user.profileType.indexOf('Administrator') !== -1 || globalConfig.user.id === row.ownerNdx
				)
			);
			var actionHTML = '<i title="Delete metric result"  ng-click="vm.deleteMetricResult(' + rowIndex + ')"  class="fa fa-trash"></i>';
			var innerHTML = hasPrivileges? actionHTML : '';
			return startingHTML + innerHTML + closingHTML;
		}

		function getFilterQueryParams() {
			var filterQueryParams = {};
			var factory = leanFilterService.getFactoryList();
			
			if (factory) {
				filterQueryParams['factory'] = factory;
			}
			
			if (leanFilterService.activeFilters.length) {
				filterQueryParams = leanFilterService.getQueryParamsObject(true);
				//Exclude supplier search
				delete filterQueryParams['supplierSearch'];
				if (filterQueryParams['spendTimePeriod']) {
					var timePeriodParams = leanFilterService.getTimePeriodFilterQueryParam('spendTimePeriod', filterQueryParams['spendTimePeriod'], true, true);
					delete filterQueryParams['spendTimePeriod'];
					filterQueryParams = _.merge(filterQueryParams, timePeriodParams);
				}
			}
			
			return filterQueryParams;
		}

		function supplierDrilldownRenderer(row, col, rowIndex, params) {
			var value = row[col.id];
			if (!value || !value.length) value = 'Supplier Not Defined';

			var filterQueryParams = getFilterQueryParams();
			if ($experiments.isEnabled('react-indirect-purchase-orders')) {
				filterQueryParams['supplierNdx'] = row['supplierNdx'];
			} else {
				filterQueryParams['supplierCode'] = row['supplierCode'];
			}

			var isIndirect = row.indirectSpendFlag || row.indirectOnly;
			var drilldownUrl = isIndirect
				? drilldownFunctionsService.getReportDrilldownUrl(
					'supply-chain/indirect-purchase-orders/',
					'react-indirect-purchase-orders',
					filterQueryParams
				)
				: addQueryParam(
					'/application/f/home.html#/supply-chain/spend-analytics/item-spend/?drilldown=1',
					null,
					filterQueryParams
				);

			var link = '<a href="' + drilldownUrl + '" target="_blank">' + value + '</a>';
			if (value === 'Supplier Not Defined') link = value;
			return '<div class="cell-div" title="' + value + '">' + link + '</div>';
		}

		function spendAnalyticsIdentifierRenderer(row, col, rowIndex, params) {
			var val = row[col.id];
			if (!val || val == '') {
				val = col.id === 'supplierName' ? 'Supplier Not Defined' :
					(col.id === 'materialGroup' ? 'MATERIAL GROUP NOT DEFINED' : 'ITEM GROUP NOT DEFINED');
			}
			var title = val;
			if (col.id == 'supplierName') {
				return supplierDrilldownRenderer(row, col, rowIndex, params);
			}
			return '<div class="cell-div" title="' + title + '">' + val + '</div>';
		}

		function strategicGoalRenderer(row, col, rowIndex, params) {
			var stateType = row['stateType'];
			var goalNdx = row['ndx'];

			var extraClass = 'with-delete';
			var linkClass = '';
			var actionElement = '<i class="fa fa-list-ul" title="Click to show projects" ng-click=\'vm.showStrategicGoalProjects(' + goalNdx + ')\'></i>';

			if (stateType === 'Archived') {
				extraClass = 'with-copy';
				actionElement += '<i class="fa fa-check" title="Click to activate goal" ng-click="vm.updateStrategicGoalStatus(' + rowIndex + ')"></i>';
			}
			if (stateType === 'Open') {
				actionElement += '<i class="fa fa-archive" title="Click to archive goal" ng-click="vm.updateStrategicGoalStatus(' + rowIndex + ')"></i>';
			}
			if (stateType === 'Archived') {
				linkClass = 'archive';
				actionElement += '<i class="fa fa-trash" title="Click to delete goal" ng-click="vm.deleteStrategicGoal(' + goalNdx + ')"></i>';
			}

			var html =  '';
			if($rootScope.authz.isAdmin()) {
				html += '<div class="cell-div inline-edit-cell"><div class="edit-name-text ' + extraClass + '">' +
					'<a ng-href="" class="anchor-link ellipsis-cell ' + linkClass + '" ng-click="vm.editStrategicGoal(' + rowIndex + ')">' + strip(row[col.id]) + '</a>' +
					'</div>' +
					'<div class="inlineActionIcons ' + extraClass + '">' + actionElement + '</div></div>';
			} else {
				html += '<div class="cell-div">' + strip(row[col.id]) + '</div>';
			}
			return html;
		}

		function analyticsSpendRenderer(row, col, rowIndx, params) {
			var colorMap = {
				'spend': '',
				'savingsBaseline': 'green',
				'increaseBaseline': 'red',
				'netPPV': 'green'
			};
			var decimals = row['decimals'];
			var val = row[col.id];
			var keepAllDecimals = col['keepAllDecimals'];
			decimals = numberOfDecimals(val, decimals, keepAllDecimals);
			if (decimals == 1) decimals = 2;
			var colorClass = '';
			if (val > 0) {
				colorClass = colorMap[col.type];
				if (col.type === 'netPPV') {
					val *= -1;
				}
			} else if (col.type === 'netPPV' && val < 0) {
				colorClass = 'red';
				val *= -1;
			}
			if (val) {
				val = currencyFormatService.getWithParametersNegativeSign(val, decimals, params.currencySymbol);
				return '<div class="cell-div shift-right viewSpendAnalyticsByItemReport ' + colorClass + '" title="' + val + '">' + val + '</div>';
			}
			return '<div class="cell-div"></div>';
		}

		function supplyOrderImpactingShortageRenderer(row, col) {
			var val = row[col.id];
			if (val === 'noValue') {
				return '<div class="cell-div invalidHighlight grayCell"></div>';
			}
			return '<div class="cell-div" title="' + val + '">' + val + '</div>';
		}

		function clearToBuildPriorityRenderer(row, col) {
			var val = row[col.id];
			if (val !== '1' && val !== 1) {
				return '<div class="cell-div"></div>';
			}
			// kind of a crude implementation
			return '<div class="cell-div" title="Flagged" style="display: flex; justify-content: center;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="src-components-lean-table-editors-common-module__redIcon"><path fill="currentColor" d="M64 496c0 8.8-7.25 16-16 16H16c-8.75 0-16-7.2-16-16V32C0 14.25 14.25 0 32 0s32 14.25 32 32v464zM476.3 0c-6.365 0-13.01 1.35-19.34 4.233-45.69 20.86-79.56 27.94-107.8 27.94-59.96 0-94.81-31.86-163.9-31.87C160.9.306 131.6 4.867 96 15.75v350.5c32-9.984 59.87-14.1 84.85-14.1 73.63 0 124.9 31.78 198.6 31.78 31.91 0 68.02-5.971 111.1-23.09C504.1 355.9 512 344.4 512 332.1V30.73C512 11.1 495.3 0 476.3 0z"></path></svg></div>';
		}

		function poRecommendationRenderer(row, col, rowIndex, params) {
			var val = row[col.id];
			if ((scheduledDeliveriesHotSheetFlag && row.forecastDeliveryCount != null && row.forecastDeliveryCount > 0) || (val == null)) {
				return '<div class="cell-div"></div>';
			}
			switch (col.id) {
			case 'poAction':
				return '<div class="cell-div">' + $translate.instant(val) + '</div>';
			case 'ageOfPoAction':
				return integer(row, col, rowIndex, params);
			case 'analysisRescheduleDate':
				return dateRenderer(row, col, rowIndex, params);
			default:
				return '<div class="cell-div"></div>';
			}
		}

		function conditionsRenderer(row, col, rowIndex, params) {
			var val = row[col.id];
			if (!val || !val.length) val = '';
			if (val == 'buyerFilter' || val.indexOf('thisBuyerOnly') === 0) val = col.columnText;
			if (row['role'] == 'Buyer') {
				var ngClickEdit = ' ng-click="vm.startEditCheckbox(' + rowIndex + ',\'' + col.id + '\')"';

				var template = '<div class="cell-div inline-edit-cell">' +
					'<div class="edit-name-text" title="' + val + '"' + ngClickEdit + ' >' +
					'<div class="name-field">' + val + '</div>' +
					editIcon(ngClickEdit) +
					'</div>' +
					'</div>';
				return template;
			}
			return '<div class="cell-div" title="' + val + '" >' + val + '</div>';
		}

		function checkboxRenderer(row, col, rowIndex, params) {
			var selected = row[col.id];
			var icon = selected ? 'fa fa-fw fa-check-square' : 'fa fa-fw fa-square-o';
			return '<div class="cell-div cell-align-center"><a href ng-click="vm.toggleCheckboxRow(' + rowIndex + ',\'' + col.id + '\')"><i class="' + icon + '"></i></a></div>';
		}

		function actionCategoryRenderer(row, col, rowIndex, params) {
			var value = row[col.id];
			var isArchived = row['isActiveCategory'];
			var cssClass = '';

			if (typeof isArchived !== 'undefined' && !isArchived) {
				cssClass = 'invalidHighlight grayCell';
				if (value && value !== 'None') {
					value += ' (archived)';
				}
			}
			// No planned supply, just show "no supply"
			return '<div class="cell-div ' + cssClass + '" title ="' + value + '">' + value + '</div>';
		}

		function metricValueRenderer(row, col, rowIndex) {
			var cellHtml = '<div class="cell-div shift-right flex-cell ' + (row.resultType === 'suspend' ? 'grayCell' : '')+ '"';
			if (row.metricType !== 'Manual' ||
				row.isCategorized ||
				globalConfig.user.profileType.indexOf('Administrator') === -1 &&
				globalConfig.user.id !== row.ownerNdx) {
				cellHtml += ' style="width:100%"';
			} else if (row.resultType === 'suspend') {
				cellHtml += ' style="width:100%"';
			} else {
				cellHtml += ' ng-hide="rowCollection[' + rowIndex + '].hasError"';
			}
			cellHtml += '>';
			if (row.resultType === 'suspend') {
				cellHtml += '<span class="no-data" title="Metric entry is suspended for this time period.">Metric entry is suspended for this time period.</span>';
			} else if (row.valueFunction === 'value') {
				cellHtml += '<span class="text-overflow-ellipsis">' + row.value + '</span>';
			} else {
				cellHtml += '<span class="text-overflow-ellipsis">' + row.valueA + ' / ' + row.valueB + '</span>';
			}
			if (row.metricType === 'Manual' &&
				!row.isCategorized &&
				row.resultType !== 'suspend' && (globalConfig.user.profileType.indexOf('Administrator') !== -1 || globalConfig.user.id === row.ownerNdx)) {
				var label = 'Edit Value';
				var inputTypeHTML = row.valueFunction === 'value' ? '\'numeric\'' : undefined;

				cellHtml += '<span class="inlineEditIcon leftPaddingOnly alwaysShowIcon" ng-hide="rowCollection[' + rowIndex + '].hasError">' +
					'<i title="Click to edit" class="fa fa-pencil" ng-click="vm.startEdit(' + rowIndex + ',\'' + col.id + '\',\'' + label + '\'' +
					',' + inputTypeHTML + ',undefined,undefined,false,true)""></i></span>' +
					'<span class="errorMsg cell-div" ng-show="rowCollection[' + rowIndex + '].hasError" style="width:100%" translate>Update failed, refresh page</span>';
			}
			cellHtml += '</div>';
			return cellHtml;
		}

		function personNameRenderer(row, col, rowIndex, params) {
			var userNdx = row.userNdx;
			var text = row[col.id];
			var link = '<a href="/application/f/home.html#/setup/user-form?userNdx=' + userNdx + '">' + text + '</a>';
			return '<div class="cell-div">' + link + '</div>';
		}

		function emailAddressRenderer(row, col, rowIndex, params) {
			var email = row[col.id];
			var bounce = row.wasBounced;
			var emailReactivationTooltip = 'Email was undeliverable to this address and it has been deactivated. Go to the Edit User page to request reactivation.';
			var cell = '<div class="cell-div">';
			cell = bounce ? cell + '<em>' : cell;
			cell += email;
			cell = bounce ? cell + '</em> <i class="fa fa-warning" style="color: #DD424F" uib-tooltip="' + emailReactivationTooltip + '"></i>' : cell;
			cell += '</div>';
			return cell;
		}

		function lastAccessRenderer(row, col, rowIndex, params) {
			var llDate = row[col.id];
			var display;
			if (!llDate) {
				display = 'No Access Yet';
			} else {
				display = $filter('date')(llDate, 'mediumDate', 'UTC');
			}
			var lastFactory = row.lastActivityFactory;
			if (lastFactory && lastFactory.length) display += ' (' + lastFactory + ')';
			return '<div class="cell-div">' + display + '</div>';
		}

		function categoryRenderer(row) {
			return '<div class="cell-div update-targets-cell extra-top-bottom-padding' + '" title="' + row.metric.categoryType + '">' + row.metric.categoryType + '</div>';
		}

		function metricRenderer(row) {
			return '<div class="cell-div update-targets-cell extra-top-bottom-padding' + '" title="' + row.metric.name + '">' + row.metric.name + '</div>';
		}

		function getFormattedValue(rawValue, displayType, currencySymbol) {
			var formattedValue = '';
			switch (displayType) {
			case 'currency':
				formattedValue = currencyFormatService.getWithParametersNegativeSign(rawValue, numberOfDecimals(rawValue), currencySymbol || globalConfig.browser.currencySymbol);
				break;
			case 'percentage':
				formattedValue = percentageFormatService.getWithParameters(rawValue);
				break;
			default:
				formattedValue = $filter('number')(rawValue);
			}
			return formattedValue;
		}

		function targetActualRenderer(row, col, rowIndex, rendParams) {
			var initialData = rendParams['initialData'] || {};
			var monthIndexLessThanFactoryStartMonth = rendParams['monthIndexLessThanFactoryStartMonth'] || 0;
			var columnType = col.type && col.type === 'Weekly' ? 'week' : 'month';
			var calculatedTargetDisabledTitle = 'You cannot edit this target. These are system generated targets.';
			var dateBeforeFactoryStartDisabledTitle = 'You cannot edit this target. This target is before the factory start date.';
			for (var i = 0; i < row.results.length; i++) {
				var month = row.results[i];
				var monthNumber = month.fiscalPeriod - 1;
				var fiscalMonth = columnType + monthNumber;
				var isMonthlyEditable = monthNumber > monthIndexLessThanFactoryStartMonth;
				var isRatioTarget = row.metric.targetValueFunction === 'valueA/valueB';
				if (fiscalMonth === col.id) {
					var target = '';
					var comparisonTarget = '';
					if (month.target || month.target === 0) {
						target = parseFloat(month.target);
						comparisonTarget = target;
					}

					var actual = !isNaN(parseFloat(month.value)) ? parseFloat(month.value) : '';
					var id = 'metric' + row.metric.ndx + '-' + 'month' + month.fiscalPeriod;

					var actualClass = '';
					if (actual || actual === 0) {
						if (comparisonTarget || comparisonTarget === 0) {
							// account for small discrepancies like floating point errors
							var absTarget = Math.abs(comparisonTarget);
							var tinyFractionOfTarget = 0.00001;
							if (absTarget < 1) {
								tinyFractionOfTarget *= absTarget;
							}
							if (initialData[row.metric.ndx].goalType.toLowerCase() === 'below') {
								if (actual <= comparisonTarget + tinyFractionOfTarget) {
									actualClass = 'green';
								} else if (actual <= comparisonTarget + absTarget * 0.1) {
									actualClass = 'yellow';
								} else {
									actualClass = 'red';
								}
							} else {
								if (actual >= comparisonTarget - tinyFractionOfTarget) {
									actualClass = 'green';
								} else if (actual >= comparisonTarget - absTarget * 0.1) {
									actualClass = 'yellow';
								} else {
									actualClass = 'red';
								}
							}
						}
						var tempActual = actual;
						actual = getFormattedValue(actual, row.metric.displayType, rendParams['currencySymbol']);
					}

					var title = '';
					if (target || target === 0) {
						title = 'Target = ' + getFormattedValue(target, row.metric.displayType, rendParams['currencySymbol']);
						target = $filter('number')(target, numberOfDecimals(target, undefined, true));
					}

					var inputClass = isRatioTarget ? 'hideInput ratio': 'hideInput';
					if (row.metric.targetPeriodType !== 'Monthly') {
						if (row.metric.cumulative) {
							title = monthlyTargetTitle;
						} else {
							title = weeklyTargetTitle;
						}
						title += ' ' + getFormattedValue(month.monthlyTarget, row.metric.displayType, rendParams['currencySymbol']);
					}

					if (isRatioTarget) {
						month.valueA = month.targetValueA || '';
						month.valueB = month.targetValueB || '';
					}

					var disabledTitle = row.metric.isCalculated ? calculatedTargetDisabledTitle : !isMonthlyEditable ? dateBeforeFactoryStartDisabledTitle : '';
					return '<div class="cell-div update-targets-cell paddingZero"><div class="targetDiv" title="' + title + '">' +
						'<input class="' + inputClass + ' firstValue" id="' + id + '" name="' + id + '" value="' + (isRatioTarget ? month.valueA: target) + '" ' +
						(row.metric.isCalculated || !isMonthlyEditable ? ' disabled="disabled" title="'+disabledTitle+'"': '') + ' />' +
						(row.metric.targetValueFunction === 'valueA/valueB' ? ' / <input class="' + inputClass + '" id="' + id + '-B" name="' + id + '-B" value="' + (isRatioTarget ? month.valueB: target) + '" ' +
							(row.metric.isCalculated || !isMonthlyEditable ? ' disabled="disabled" title="'+disabledTitle+'"': '') + ' />': '') +
						'</div><div class="actualDiv ' + actualClass + '" title="' + actual + '">' + actual + '</div></div>';
				}
			}
		}

		function targetActualHeaderRenderer(row) {
			var metricName = row.metric.name.replace(/'/g, '');
			var targetHeader = 'Target';
			var isRatioTarget = row.metric.targetValueFunction === 'valueA/valueB';
			if (row.metric.targetPeriodType !== 'Monthly') {
				targetHeader = row.metric.targetPeriodType + ' Target';
			}
			return '<div class="cell-div targetHeaderDiv" title="' + targetHeader + '">' +
				'<div class="target-with-copy">' + targetHeader + '</div>' +
				(row.metric.isCalculated ? '' : '<span ng-click="vm.copyMetricTargets(\'' + metricName + '\',\'' + row.metric.ndx + '\', \'' + row.metric.targetPeriodType + '\',' + isRatioTarget + ')" ' +
					'class="fa fa-copy copy-row"></span>') +
				'</div><div class="cell-div actualHeaderDiv ' +
				'" title="' + 'Actual' + '">' + 'Actual' + '</div>';
		}

		function valueStreamReportCardRenderer(row, col, rowIndx, params) {
			var valueStreamNdx = row['ndx'];
			var userNdx = row['userNdx'];
			var valueStreamName = row[col.id];
			if (valueStreamNdx) {
				return '<div ng-click="vm.openReportCard(' + valueStreamNdx + ', \'' + encodeURI(valueStreamName) + '\',' + userNdx + ')" class="cell-div" title="' + valueStreamName + '">' + valueStreamName + '</div>';
			}
			return '<div class="cell-div"></div>';
		}

		function minmaxLevelRenderer(row, col, rowIndex, params) {
			if (row['orderPolicy'] != 'MinMax') {
				return '<div class="cell-div"></div>';
			}
			return integer(row, col, rowIndex, params);
		}

		function minmaxEffectiveDateRenderer(row, col, rowIndex, params) {
			if (row['orderPolicy'] != 'MinMax' || row[col.id] == '1970-01-01') {
				return '<div class="cell-div"></div>';
			}
			return dateRenderer(row, col, rowIndex, params);
		}

		function projectTypeRenderer(row, col, rowIndex, params) {
			var projectTypeId = row['id'];

			var extraClass = 'with-delete with-action';
			var actionElement = '<i class="fa fa-trash" title="Click to delete project type" ng-click="vm.deleteProjectType(' + rowIndex + ')"></i>';

			var html = '';
			if ($rootScope.authz.isAdmin()) {
				html += '<div class="cell-div inline-edit-cell"><div class="edit-name-text ' + extraClass + '">' +
					'<a ng-href="" class="anchor-link" ng-click="vm.editProjectType(' + rowIndex + ')">' + strip(row[col.id]) + '</a>' +
					'</div>' +
					'<div class="inlineActionIcons ' + extraClass + '">' + actionElement + '</div></div>';
			} else {
				html += '<div class="cell-div">' + strip(row[col.id]) + '</div>';
			}
			return html;
		}

		function projectSavingsCategoryRenderer(row, col, rowIndex, params) {
			var status = row['status'];

			var extraClass = 'with-delete with-action';
			var linkClass = 'anchor-link';
			// Exclude the delete for now.
			var actionElement = '';
			if (status === 'Archive') {
				linkClass += ' archive';
				actionElement += '<i class="fa fa-undo" title="Click to activate Savings Category" ng-click="vm.updateProjectSavingsCategoryStatus(' + rowIndex + ')"></i>';
			}
			if (status === 'Active') {
				actionElement += '<i class="fa fa-archive" title="Click to archive Savings Category" ng-click="vm.updateProjectSavingsCategoryStatus(' + rowIndex + ')"></i>';
			}

			var html = '';
			if ($rootScope.authz.isAdmin()) {
				html += '<div class="cell-div inline-edit-cell"><div class="edit-name-text ' + extraClass + '">' +
					'<a ng-href="" class="' + linkClass + '" ng-click="vm.editProjectSavingsCategory(' + rowIndex + ')">' + strip(row[col.id]) + '</a>' +
					'</div>' +
					'<div class="inlineActionIcons">' + actionElement + '</div>' +
					'</div>';
			} else {
				html += '<div class="cell-div">' + strip(row[col.id]) + '</div>';
			}
			return html;
		}

		function projectAreaRenderer(row, col, rowIndex, params) {
			var val = row[col.id];
			if (col.requiredPermission) {
				var hasPrivileges;
				if (col.requiredPermission === 'adminOrUser') {
					hasPrivileges= $rootScope.authz.isAdmin() || row.userNdx == globalConfig.user.id;
				}
				if (col.requiredPermission === 'admin') {
					hasPrivileges= $rootScope.authz.isAdmin();
				}
				if (!hasPrivileges) return '<div class="cell-div" title="' + val + '">' + val + '</div>';
			}
			if (col.id === 'target') {
				var decimals = row.targetDecimals = undefined;
				if (val % 1 === 0) {
					decimals = 0;
				}
				val = currencyFormatService.getWithParametersNegativeSign(val, decimals, params.currencySymbol);
			}
			if (val === undefined) {
				val = '';
			}
			var label = col.editLabel || 'Edit ' + col.display;
			var inputType = col.inputType;
			var inputTypeHTML = inputType ? "'" + inputType + "'" : 'undefined';
			var maxLength = col.maxLength;
			var maxLengthHTML = maxLength ? "'" + maxLength + "'" : 'undefined';
			var deleteHTML = col.deleteFunction
				?  '<i title="Delete Area"  ng-click="vm.' + col.deleteFunction + '(' + rowIndex + ')"  class="fa fa-trash"></i>'
				: '';
			var withDeleteClassHTML = col.deleteFunction ? ' with-delete' : ' with-action';
			var controllerName = params && params.controllerName;
			var controllerNameHTML = controllerName ? "'" + controllerName + "'" : 'undefined';
			var editFunction = col.editFunction || 'startEdit';
			return '<div class="cell-div inline-edit-cell">' +
				'<div class="edit-name-text' + withDeleteClassHTML + '" title="' + val + '">' + val + '</div>' +
				'<div class="inlineActionIcons' + withDeleteClassHTML + '" id="actionIcons">' +
				'<i class="fa fa-pencil"	title="Click to edit" ng-click="vm.' + editFunction + '(' + rowIndex + ',\'' + col.id + '\',\'' + label + '\'' +
				',' + inputTypeHTML + ',' + maxLengthHTML + ',' + controllerNameHTML + ',' + col.allowBlank + ',\'' + col.addPlaceholder + '\')"></i>' +
				deleteHTML + '</div></div>';
		}

		function projectAreaTargetRenderer(row, col, rowIndex, params) {

		}


		function yesNoSSOActive(row, col, rowIndex, params) {
			var activeText = '';
			if (row.isActive == '1') {
				activeText = ' title="{{\'Active\' | translate}}" ng-click="vm.disableSamlProfile(' + row.id + ')"><i class="fa fa-toggle-on"></i>';
			} else {
				activeText = ' title="{{\'Disabled\' | translate}}" ng-click="vm.activateSamlProfile(' + row.id + ')"><i class="fa fa-toggle-off"></i>';
			}
			var html = '';
			html= '<div class="cell-div shift-right">' +
				'<button class="noStyleButton" ' + activeText + '</button>' +
				'</div >';
			return html;
		}

		function configSSOActionRenderer(row, col, rowIndex, params) {
			var activeText = '';
			if (row.useLegacyEntityID == '1') {
				activeText = ' title="{{\'Toggle Legacy Entity ID\' | translate}}" ng-click="vm.toggleLegacyEntityID(' + row.id + ')"><i class="fa fa-toggle-on"></i>';
			} else {
				activeText = ' title="{{\'Toggle Legacy Entity ID\' | translate}}" ng-click="vm.toggleLegacyEntityID(' + row.id + ')"><i class="fa fa-toggle-off"></i>';
			}
			var html = '';
			if ($rootScope.authz.isAdmin()) {
				html = '<div class="cell-div shift-right">' +
				'<button class="noStyleButton" title="{{\'Delete the SAML profile\' | translate}}" ng-click="vm.deleteSamlProfile(' + row.id + ')"><i class="fa fa-trash"></i></button> ' +
				'<button class="noStyleButton" title="{{\'Edit the SAML profile\' | translate}}" ng-click="vm.editSamlProfile(' + row.id + ')"><i class="fa fa-edit"></i></button>' +
				'<button class="noStyleButton" ' + activeText + '</button>' +
				'</div>';
			}
			return html;
		}

		function resolveSupplierNdxs(row, col, rowIndex, params) {
			//use suplier service here
			var supplierList = supplierListService.getSupplierList();
			if (!row['supplierNdxs'] || Object.keys(supplierList).length ===0) {
				return '<div class="cell-div"></div>';
			}
			var supplierNdxs = row['supplierNdxs'].split(',');
			var supplierNames = new Set();
			angular.forEach(supplierNdxs, function (supplierNdx) {
				var supplierName = supplierList[supplierNdx];
				if (supplierName) {
					supplierNames.add(supplierName);
				}
			});
			var supplierText = Array.from(supplierNames).join(', ');
			return '<div class="cell-div" title="' + supplierText + '">' + supplierText + '</div>';
		}

		function projectCategoryRenderer(row, col, rowIndex) {
			var status = row['status'];

			var extraClass = 'with-delete';
			var linkClass = '';
			var actionElement = '<i class="fa fa-pencil" title="Click to edit project category" ng-click="vm.startEdit(' + rowIndex + ',\'' + col.id + '\',\'Edit Project Category name\', \'text\', 120, \'projectCategories\')"></i>';
			if (status === 'Archive') {
				linkClass += 'archive';
				extraClass += ' with-archive';
				actionElement += '<i class="fa fa-undo" title="Click to activate project category" ng-click="vm.updateProjectCategoryStatus(' + rowIndex + ', \'Active\')"></i>';
				actionElement += '<i class="fa fa-trash" title="Click to delete project category" ng-click="vm.deleteProjectCategory(' + rowIndex + ')"></i>';
			}
			if (status === 'Active') {
				actionElement += '<i class="fa fa-archive" title="Click to archive project category" ng-click="vm.updateProjectCategoryStatus(' + rowIndex + ', \'Archive\')"></i>';
			}

			var html =
				'<div class="cell-div inline-edit-cell">' +
					'<div class="edit-name-text no-edit ' + extraClass + '">' +
						'<div class="' + linkClass + '">' + strip(row[col.id]) + '</div>' +
					'</div>' +
					'<div class="inlineActionIcons">' + actionElement + '</div>' +
				'</div>';
			return html;
		}

		function workbenchNonCompliantPoRenderer(row, col, rowIndex, params) {
			var nonCompliantType = col['nonCompliantType'];
			var rawValue = row[col.id];
			var classString = 'class="cell-div shift-right" ';
			var summarySupplierUrl = 'my-work/summary-workbench/supplier/all';

			if (rawValue == null) {
				return '<div ' + classString + '></div>';
			}
			var supplierNdxs = row['supplierNdxs'] || '';
			var factoryNdxs = row['leanDirFactoryNdxs'];

			var paramObj = {
				supplierNdx: supplierNdxs.split(','),
				factory: factoryNdxs.split(','),
				compliantState: 'NON_COMPLIANT'
			};

			if (nonCompliantType === 'adjustmentRequest') {
				paramObj.tab = 'AdjustmentRequest';
			} else if (nonCompliantType === 'missingCommitDate') {
				paramObj.tab = 'Info';
			} else if (nonCompliantType === 'pastDueCommitDate') {
				paramObj.tab = 'Info';
				paramObj.goldenSupplyDate = { filterType: 'rangeFilter', comparator: 'Less Than', valueOne: 0 };
			} else if (nonCompliantType === 'rejectedCommitDate') {
				paramObj.tab = 'Info';
				paramObj.approvalStatus = 'REJECTED';
			} else {
				return '<div ' + classString + '>' + rawValue + '</div>';
			}

			var url = drilldownFunctionsService.getReportDrilldownUrl(summarySupplierUrl, '', paramObj, true);
			return '<div ' + classString + '><a href="' + url + '" target="_blank">' + rawValue + '</a></div>';
		}

		function commitDateCoverageRenderer(row, col, rowIndex, params) {
			var rawValue = row[col.id];
			var classString = 'class="cell-div shift-right" ';

			if (!row['isWhitelisted']) {
				return '<div ' + classString + '></div>';
			}

			if (!rawValue && rawValue !== 0) {
				return '<div ' + classString + '>100%</div>';
			}

			var percentValue = rawValue * 100;
			var integerPercent = convertInteger(Math.floor(percentValue));

			if (globalConfig.user.role == 'Supplier' && !authorize(['supplyChain', 'purchaseOrders'])) {
				return '<div ' + classString + ' title="' + integerPercent + '%">' + integerPercent + '% </div>';
			}

			var supplierNdxs = row['supplierNdxs'] || '';
			var factoryNdxs = row['leanDirFactoryNdxs'];

			var filters = {
				supplierNdx: supplierNdxs.split(','),
				factory: factoryNdxs.split(','),
				tab: 'AllOpen',
				autoOpenComplianceDrawer: true
			};
			var url = drilldownFunctionsService.getReportDrilldownUrl('my-work/summary-workbench/supplier/all', '', filters, true);
			var returnValue = '<a href="' + url + '" target="_blank">' + integerPercent + '%</a>';
			return '<div ' + classString + ' title="' + integerPercent + '%">' + returnValue + ' </div>';
		}

		function reportingPeriodRenderer(row, col, rowIndex, params) {
			var result = '';
			if (row['reportingPeriod']) {
				var components = row['reportingPeriod'].split(';');
				var periodType = components[0];

				if (periodType == 'm') {
					var targetDate = components[1];
					var formattedDate = $filter('date')(targetDate, 'MMM yyyy');
					result = formattedDate;
				} else {
					var fiscalPeriod = components[1];
					var fiscalYear = components[2];
					if (fiscalPeriod && fiscalPeriod.length > 0) {
						result = periodType.toUpperCase() + fiscalPeriod + ' ' + fiscalYear;
					}
				}
			}
			return '<div class="cell-div">' + result + '</div>';
		}

		function poIdentifier(row, col, rowIndex, params) {
			var poNumber = row.firstPurchaseOrderNumber || row.supplyOrderNumber || row.purchaseOrderNumber || row.orderNumber;
			var poLine = row.firstPurchaseOrderLine || row.orderLine || row.purchaseOrderLine;
			var scheduleLine = row.firstPurchaseOrderScheduleLine || row.scheduleLine;

			if (poNumber && poLine && scheduleLine) {
				var contentString = poNumber + ':' + poLine + ':' + scheduleLine;
				return '<div class="cell-div invalidHighlight" title ="' + contentString + '">' + renderChatWithContent(isChatEnabled, rowIndex, params, contentString, row) + '</div>';
			} else {
				return '<div class="cell-div"></div>';
			}
		}

		function isBlanketOrder(row, col, rowIndex, params) {
			var cellText = row.isBlanketOrder ? 'Yes' : 'No';
			return '<div class="cell-div">'+cellText+'</div>';
		}

		function isMoveInForRequirement(row, col, rowIndex, params) {
			var cellText = row.isMoveInForRequirement ? 'Yes' : 'No';
			return '<div class="cell-div">'+cellText+'</div>';
		}

	}
})();
